"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8656],{

/***/ 63837:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "IV": () => (/* reexport */ withExperimentTrackingStringProvider),
  "ut": () => (/* reexport */ withReferrerProvider)
});

// UNUSED EXPORTS: withDeviceAndThemeProvider

// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/hoc/withDeviceAndThemeProvider.tsx
var withDeviceAndThemeProvider = __webpack_require__(12390);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/ExperimentTrackingStringContext.ts
var ExperimentTrackingStringContext = __webpack_require__(45658);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hoc/withExperimentTrackingStringProvider.tsx


function withExperimentTrackingStringProvider(comp, experiment) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ExperimentTrackingStringContext/* ExperimentTrackingString.Provider */.M.Provider, {
    value: experiment,
    children: comp
  });
}
// EXTERNAL MODULE: ../../libs/ui-widgets/src/lib/Contexts/ReferrerContext.ts
var ReferrerContext = __webpack_require__(90932);
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hoc/withReferrerProvider.tsx


function withReferrerProvider(comp, referrer) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ReferrerContext/* default.Provider */.Z.Provider, {
    value: referrer,
    children: comp
  });
}
;// CONCATENATED MODULE: ../../libs/ui-widgets/src/lib/hoc/index.ts




/***/ }),

/***/ 73826:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": () => (/* binding */ FormHeaderFlex),
/* harmony export */   "Ct": () => (/* binding */ Badge),
/* harmony export */   "Dd": () => (/* binding */ SegmentContent),
/* harmony export */   "E6": () => (/* binding */ LabelWithIcon),
/* harmony export */   "EP": () => (/* binding */ ProductBanner),
/* harmony export */   "G_": () => (/* binding */ TravellerText),
/* harmony export */   "NA": () => (/* binding */ PersuasionText),
/* harmony export */   "PK": () => (/* binding */ ErrorToast),
/* harmony export */   "QS": () => (/* binding */ CalendarDropdownWrap),
/* harmony export */   "Rk": () => (/* binding */ RadioItem),
/* harmony export */   "SI": () => (/* binding */ SegmentContainer),
/* harmony export */   "TW": () => (/* binding */ TravelFormWrapper),
/* harmony export */   "Uj": () => (/* binding */ SegmentFlexContainer),
/* harmony export */   "WW": () => (/* binding */ SegmentTag),
/* harmony export */   "Wb": () => (/* binding */ SegmentWrapper),
/* harmony export */   "XZ": () => (/* binding */ Checkbox),
/* harmony export */   "Y$": () => (/* binding */ TripOptionsContainer),
/* harmony export */   "_R": () => (/* binding */ SegmentMainContainer),
/* harmony export */   "__": () => (/* binding */ Label),
/* harmony export */   "bZ": () => (/* binding */ DatePickerHeader),
/* harmony export */   "bh": () => (/* binding */ SegmentButton),
/* harmony export */   "bk": () => (/* binding */ TravelFormContainer),
/* harmony export */   "cM": () => (/* binding */ DatePickerHeaderInner),
/* harmony export */   "e0": () => (/* binding */ ArrowIcon),
/* harmony export */   "fb": () => (/* binding */ FormContent),
/* harmony export */   "gk": () => (/* binding */ ErrorSpan),
/* harmony export */   "hj": () => (/* binding */ FormSection),
/* harmony export */   "i_": () => (/* binding */ SubText),
/* harmony export */   "iz": () => (/* binding */ Divider),
/* harmony export */   "kI": () => (/* binding */ DateMonthYear),
/* harmony export */   "kc": () => (/* binding */ DateNumber),
/* harmony export */   "ke": () => (/* binding */ CheckboxLabel),
/* harmony export */   "mb": () => (/* binding */ SegmentHeader),
/* harmony export */   "ph": () => (/* binding */ FormHeader),
/* harmony export */   "q": () => (/* binding */ TravellerNumber),
/* harmony export */   "qk": () => (/* binding */ IconContainer),
/* harmony export */   "tp": () => (/* binding */ CheckboxContainer),
/* harmony export */   "u1": () => (/* binding */ BannerIcon),
/* harmony export */   "ub": () => (/* binding */ LabelWrapper),
/* harmony export */   "v": () => (/* binding */ TrailingBannerIcon),
/* harmony export */   "vO": () => (/* binding */ SegmentOptions),
/* harmony export */   "y": () => (/* binding */ BannerContent),
/* harmony export */   "yS": () => (/* binding */ CTAWrapper),
/* harmony export */   "zr": () => (/* binding */ MainText)
/* harmony export */ });
/* unused harmony exports BannerInfo, CalendarDropdown, TravellerDropdown, NumberItem */
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42874);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82740);


const breakpoints = {
  lg: "992px"
};
const TravelFormWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__TravelFormWrapper",
  componentId: "sc-17uae6l-0"
})(["width:1200px;margin:60px auto 0px auto;background-size:100%;overflow:visible;@media (max-width:768px){width:100%;min-width:320px;overflow-x:auto;}"]);
const LabelWithIcon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__LabelWithIcon",
  componentId: "sc-17uae6l-1"
})(["display:flex;align-items:baseline;gap:4px;margin-bottom:6px;"]);
const TravelFormContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__TravelFormContainer",
  componentId: "sc-17uae6l-2"
})(["padding:55px 16px 16px 16px;background:", ";border-radius:8px;font-family:sans-serif;box-shadow:0 2px 8px rgba(0,0,0,0.1);align-self:center;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText);
const FormHeader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__FormHeader",
  componentId: "sc-17uae6l-3"
})([""]);
const ProductBanner = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__ProductBanner",
  componentId: "sc-17uae6l-4"
})(["display:flex;background:radial-gradient( 75.36% 140.35% at 100% 0%,#ead4ff 0%,#ffffff 100% );align-items:center;font-size:0.9rem;height:42px;", " ", ""], props => props.isRevamp && `padding: 5px 12px;
     border-radius: 8px;
     margin-bottom: 8px;`, props => !props.isRevamp && `
  padding-right: 40px; 
  border-top-right-radius: 45px;
  `);
const FormHeaderFlex = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__FormHeaderFlex",
  componentId: "sc-17uae6l-5"
})(["display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:1rem;"]);
const PersuasionText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
  displayName: "CommonLandingDTstyle__PersuasionText",
  componentId: "sc-17uae6l-6"
})(["font-size:18px;color:", ";padding:0px 12px;text-align:right;font-weight:700;font-size:16px;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText */ .rS.greyText);
const BannerIcon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__BannerIcon",
  componentId: "sc-17uae6l-7"
})(["margin-right:4px;width:24px;height:20px;", ""], isRevamp => isRevamp ? `margin-left: 0px;` : `margin-left: 16px;`);
const TrailingBannerIcon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__TrailingBannerIcon",
  componentId: "sc-17uae6l-8"
})(["margin-left:4px;height:16px;cursor:pointer;"]);
const BannerContent = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__BannerContent",
  componentId: "sc-17uae6l-9"
})(["display:flex;align-items:center;gap:0.5rem;white-space:nowrap;", ""], isRevamp => isRevamp ? `font-size: 12px;` : `font-size: 14px;`);
const BannerInfo = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__BannerInfo",
  componentId: "sc-17uae6l-10"
})(["margin-left:6px;"]);
const FormContent = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__FormContent",
  componentId: "sc-17uae6l-11"
})(["display:flex;align-items:flex-start;border:1px solid ", ";border-radius:10px;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.darkGreyBg */ .rS.darkGreyBg);
const FormSection = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__FormSection",
  componentId: "sc-17uae6l-12"
})(["padding:8px 16px 12px 16px;position:relative;overflow:visible;&:nth-of-type(1){flex:0.5;}&:nth-of-type(3){flex:0.25;}&:nth-of-type(5){flex:0.25;}&:not(:last-child)::after{content:\"\";position:absolute;right:0;top:0;height:100%;width:1px;}"]);
const Label = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "CommonLandingDTstyle__Label",
  componentId: "sc-17uae6l-13"
})(["color:", ";margin-bottom:4px;margin-top:8px;font-size:14px;font-weight:900;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText */ .rS.greyText);
const Badge = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__Badge",
  componentId: "sc-17uae6l-14"
})(["background:", ";color:", ";font-weight:900;font-size:14px;border-radius:5px;padding:2px 10px;display:inline-block;margin-top:8px;letter-spacing:1px;text-align:center;width:fit-content;line-height:20px;"], ({
  bgColor
}) => bgColor.length > 1 ? `linear-gradient(to right, ${bgColor.join(", ")})` : bgColor[0] || "#53B2FE", _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText);
const MainText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "CommonLandingDTstyle__MainText",
  componentId: "sc-17uae6l-15"
})(["font-size:1.25rem;font-weight:bold;display:flex;align-items:baseline;"]);
const DateNumber = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "CommonLandingDTstyle__DateNumber",
  componentId: "sc-17uae6l-16"
})(["font-family:Lato;font-weight:700;font-size:32px;line-height:100%;letter-spacing:0px;"]);
const DateMonthYear = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "CommonLandingDTstyle__DateMonthYear",
  componentId: "sc-17uae6l-17"
})(["font-family:Lato;font-weight:400;font-size:22px;line-height:100%;letter-spacing:0%;margin-left:4px;"]);
const CalendarDropdown = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__CalendarDropdown",
  componentId: "sc-17uae6l-18"
})(["position:absolute;top:100%;left:0;right:0;z-index:9999;background-color:white;box-shadow:0 4px 12px rgba(0,0,0,0.15);border-radius:8px;margin-top:8px;width:600px;overflow:visible;transform:translateY(0);&:before{content:\"\";position:absolute;top:-8px;left:20px;width:16px;height:16px;background-color:white;transform:rotate(45deg);box-shadow:-2px -2px 5px rgba(0,0,0,0.06);}.rdp{margin:0;padding:16px;}.rdp-month{margin:0 8px;}.rdp-day_selected{background-color:var(--tm-accent-color);}.rdp-day_range_middle{background-color:#e5efff;}.rdp-day_range_end,.rdp-day_range_start{background-color:var(--tm-accent-color);}"]);
const TravellerNumber = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "CommonLandingDTstyle__TravellerNumber",
  componentId: "sc-17uae6l-19"
})(["font-size:32px;font-weight:700;line-height:100%;font-family:Lato;letter-spacing:0px;"]);
const TravellerText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "CommonLandingDTstyle__TravellerText",
  componentId: "sc-17uae6l-20"
})(["font-family:Lato;font-weight:400;font-size:22px;line-height:100%;letter-spacing:0%;margin-left:4px;"]);
const TravellerDropdown = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__TravellerDropdown",
  componentId: "sc-17uae6l-21"
})(["position:absolute;z-index:10;background:", ";width:100%;left:0;box-shadow:0 2px 8px rgba(0,0,0,0.12);border-radius:8px;top:100%;max-height:240px;overflow-y:auto;scrollbar-width:thin;&::-webkit-scrollbar{width:6px;}&::-webkit-scrollbar-track{background:#f1f1f1;border-radius:3px;}&::-webkit-scrollbar-thumb{background:#c1c1c1;border-radius:3px;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText);
const NumberItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__NumberItem",
  componentId: "sc-17uae6l-22"
})(["padding:12px 16px;text-align:center;font-size:16px;cursor:pointer;font-weight:", ";color:", ";background-color:", ";&:hover{background-color:#f9f9f9;}"], ({
  isSelected
}) => isSelected ? "700" : "400", ({
  isSelected
}) => isSelected ? "#008CFF" : "#333", ({
  isSelected
}) => isSelected ? "#f5f9ff" : "transparent");
const Divider = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__Divider",
  componentId: "sc-17uae6l-23"
})(["align-self:stretch;width:1px;background-color:#e0e0e0;"]);
const SubText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "CommonLandingDTstyle__SubText",
  componentId: "sc-17uae6l-24"
})(["font-size:14px;color:", ";margin-bottom:2px;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText */ .rS.greyText);
const ArrowIcon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].img.withConfig */ .ZP.img.withConfig({
  displayName: "CommonLandingDTstyle__ArrowIcon",
  componentId: "sc-17uae6l-25"
})(["width:9px;height:9px;@media (min-width:", "){width:9px;height:9px;}margin-left:4px;transform:", ";transition:transform 0.3s ease-in-out;"], breakpoints.lg, props => props.isRotated ? "rotate(180deg)" : "rotate(0deg)");
const SegmentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__SegmentWrapper",
  componentId: "sc-17uae6l-26"
})(["margin-top:28px;display:flex;align-items:center;gap:16px;"]);
const LabelWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__LabelWrapper",
  componentId: "sc-17uae6l-27"
})(["flex:0 0 auto;", "{white-space:nowrap;margin:0;}"], Label);
const SegmentHeader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__SegmentHeader",
  componentId: "sc-17uae6l-28"
})(["display:flex;align-items:center;font-size:14px;font-weight:900;color:", ";"], ({
  selected
}) => selected ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText : _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText */ .rS.greyText);
const SegmentFlexContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__SegmentFlexContainer",
  componentId: "sc-17uae6l-29"
})(["display:flex;align-items:flex-start;justify-content:space-between;gap:20px;width:auto;"]);
const SegmentMainContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__SegmentMainContainer",
  componentId: "sc-17uae6l-30"
})(["flex:1;"]);
const SegmentContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__SegmentContainer",
  componentId: "sc-17uae6l-31"
})(["flex:1;"]);
const SegmentOptions = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__SegmentOptions",
  componentId: "sc-17uae6l-32"
})(["display:flex;gap:8px;flex:1;"]);
const SegmentButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "CommonLandingDTstyle__SegmentButton",
  componentId: "sc-17uae6l-33"
})(["border:1px solid ", ";background-color:", ";border-radius:8px;padding:4px 8px;cursor:pointer;position:relative;transition:all 0.2s ease;display:flex;align-items:flex-start;margin-bottom:8px;", " p{font-weight:", ";color:", ";}", "{color:", ";}"], ({
  selected
}) => selected ? " #008CFF" : "#ccc", ({
  selected
}) => selected ? "#EAF5FF" : "#fff", SegmentHeader, ({
  selected
}) => selected ? "500" : "normal", ({
  selected
}) => selected ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText : _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText */ .rS.greyText, SubText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText6 */ .rS.greyText6);
const SegmentTag = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__SegmentTag",
  componentId: "sc-17uae6l-34"
})(["position:absolute;top:-12px;left:10px;min-width:40px;background:", ";color:white;padding:2px 6px;border-radius:4px;font-size:10px;font-weight:700;display:flex;align-items:center;justify-content:center;"], ({
  startColor,
  endColor
}) => `linear-gradient(to right, ${startColor}, ${endColor})`);
const CTAWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__CTAWrapper",
  componentId: "sc-17uae6l-35"
})(["margin-top:2rem;text-align:center;button{border-radius:38px;}"]);
const CheckboxContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__CheckboxContainer",
  componentId: "sc-17uae6l-36"
})(["position:relative;display:flex;align-items:flex-start;margin-right:8px;margin-top:4px;"]);
const Checkbox = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input.withConfig */ .ZP.input.withConfig({
  displayName: "CommonLandingDTstyle__Checkbox",
  componentId: "sc-17uae6l-37"
})(["position:absolute;opacity:0;cursor:pointer;height:0;width:0;"]);
const CalendarDropdownWrap = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__CalendarDropdownWrap",
  componentId: "sc-17uae6l-38"
})(["width:592px;background:", ";box-sizing:border-box;display:flex;flex-direction:column;z-index:1;border-radius:4px;box-shadow:0px 1px 7px rgba(0,0,0,0.2);position:absolute;left:0;top:30px;.calenderHeader{margin-top:0;}.rdp-cell{width:38px;height:38px;}.rdp-cell:hover{border-radius:0;}.rdp-weeknumber,.rdp-day{font-size:12px;width:38px;height:38px;}.rdp-day_selected,.rdp-day_selected:focus-visible{background:#eaf5ff;color:", ";border-radius:0;}.rdp-day_range_start,.rdp-day_range_end{background:", ";border-radius:0px 2px 2px 0px;color:", ";}.rdp-head_cell{font-weight:700;font-size:12px;line-height:16px;color:", ";}.rdp-caption_label{font-weight:400;font-size:18px;line-height:25px;color:", ";}.rdp-caption_label .boldText{font-weight:700;}.rdp-day_today{font-weight:400;}.rdp-button svg{display:none;}.rdp-button:hover:not([disabled]):not(.rdp-day_selected){background:", ";border-radius:0;}.rdp-nav_button_previous:before,.rdp-nav_button_next:before{position:absolute;top:20px;content:\"\";width:20px;height:2px;background:", ";border-radius:2px;background-image:none;}.rdp-nav_button_previous:after{left:7px;transform:rotate(-45deg);}.rdp-nav_button_next:after{right:7px;transform:rotate(135deg);}.rdp-nav_button_previous:after,.rdp-nav_button_next:after{position:absolute;top:17px;content:\"\";width:8px;height:8px;background-image:none;border-top:solid 2px ", ";border-left:solid 2px ", ";}&.single-date-mode .rdp-day_selected,&.single-date-mode .rdp-day_selected:focus-visible{background:", " !important;color:#fff !important;border-radius:2px;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blackText */ .rS.blackText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.greyText4 */ .rS.greyText4, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blackText */ .rS.blackText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightBlueBg */ .rS.lightBlueBg, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText);
const ErrorToast = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__ErrorToast",
  componentId: "sc-17uae6l-39"
})(["border-radius:6px;background:", ";padding:12px 16px;margin:0 16px 16px;width:auto;color:#d32f2f;"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightRed */ .rS.lightRed);
const CheckboxLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].label.withConfig */ .ZP.label.withConfig({
  displayName: "CommonLandingDTstyle__CheckboxLabel",
  componentId: "sc-17uae6l-40"
})(["position:relative;cursor:pointer;height:20px;width:20px;background-color:white;border:2px solid #ccc;border-radius:50%;display:flex;align-items:center;justify-content:center;transition:all 0.2s ease;&:after{content:\"\";position:absolute;display:none;width:10px;height:10px;background-color:", ";border-radius:50%;}", ":checked + &&{border-color:", ";}", ":checked + &&:after{display:block;}"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, Checkbox, _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.blueText */ .rS.blueText, Checkbox);
const SegmentContent = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__SegmentContent",
  componentId: "sc-17uae6l-41"
})(["display:flex;flex-direction:column;justify-content:flex-start;margin-top:4px;"]);
const ErrorSpan = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "CommonLandingDTstyle__ErrorSpan",
  componentId: "sc-17uae6l-42"
})(["color:#e53e3e;font-size:14px;margin-top:4px;display:block;"]);
const DatePickerHeader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__DatePickerHeader",
  componentId: "sc-17uae6l-43"
})(["padding:8px;background-color:", ";"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText);
const DatePickerHeaderInner = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__DatePickerHeaderInner",
  componentId: "sc-17uae6l-44"
})(["padding:8px;border-radius:4px;background-color:", ";"], _tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightBlueBg */ .rS.lightBlueBg);
const RadioItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__RadioItem",
  componentId: "sc-17uae6l-45"
})(["display:flex;align-items:center;gap:10px;padding:4px 8px;font-size:14px;", ""], props => props.isSelected ? `
  background: ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.lightBlueBg */ .rS.lightBlueBg};
  border-radius: 16px;
  font-weight: 900;
  ` : `
  background: ${_tm_utility_global__WEBPACK_IMPORTED_MODULE_0__/* .theme.whiteText */ .rS.whiteText};
  font-weight: 400;
  `);
const TripOptionsContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__TripOptionsContainer",
  componentId: "sc-17uae6l-46"
})(["display:flex;gap:10px;"]);
const IconContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CommonLandingDTstyle__IconContainer",
  componentId: "sc-17uae6l-47"
})(["width:16px;height:16px;"]);

/***/ }),

/***/ 56397:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83636);
/* harmony import */ var _tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50354);
/* harmony import */ var _tm_insurance_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78521);
/* harmony import */ var _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(576);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62663);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44928);
/* harmony import */ var _tm_static__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48359);
/* harmony import */ var _tm_utility__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97427);
/* harmony import */ var _tm_utility_global__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42874);
/* harmony import */ var libs_utility_src_lib_analytics_XDMAnalytics_xdmEvents__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46535);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2784);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(84576);
/* harmony import */ var _Toast_WebToast__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(78891);
/* harmony import */ var _tm_utility_analytics__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11508);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(73826);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(52322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








 // import { SelectCountryModalV2 } from "@tm/static";






 // Lazy load calendar component (client-only)

const CalendarDropdown = next_dynamic__WEBPACK_IMPORTED_MODULE_11___default()(() => __webpack_require__.e(/* import() */ 3992).then(__webpack_require__.bind(__webpack_require__, 53992)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(53992)]
  }
});
const CalendarPersuasionModal = next_dynamic__WEBPACK_IMPORTED_MODULE_11___default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 48359)).then(mod => mod.CalendarPersuasionModal), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(48359)]
  }
});
const DropOffModal = next_dynamic__WEBPACK_IMPORTED_MODULE_11___default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 48359)).then(mod => mod.DropOffModal), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(48359)]
  }
});
const InfoModal = next_dynamic__WEBPACK_IMPORTED_MODULE_11___default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 48359)).then(mod => mod.InfoModal), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(48359)]
  }
}); // Lazy load segment modal (client-only, on demand)

const SegmentModal = next_dynamic__WEBPACK_IMPORTED_MODULE_11___default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 21348)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(21348)]
  }
}); // Lazy load country modal (client-only, on demand)

const SelectCountryModalV2 = next_dynamic__WEBPACK_IMPORTED_MODULE_11___default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 38051)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(38051)]
  }
});







//TODO: refactor this component logically to reduce state and code complexity and remove symbo flow related changes
const CommonLandingDT = ({
  data,
  query,
  pokus,
  countryCode,
  seoPageType,
  segmentId
}) => {
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_16__.useRouter)();
  const isCommonLandingRevamp = pokus?.isCommonLandingRevamp || false;
  const travelFormInfo = data?.travelFormInfo;
  const recentSearches = data?.recentSearches;
  const prePopulatedData = data?.prePopulatedData;
  const showOnLand = data?.dropOffBottomSheet?.showOnLand || false;
  const minDurationDaysForCalendarPersuasion = data?.calendarBottomSheet?.minimumDurationDays || 360; // const travellerInfoSection = travelFormInfo?.travellerInfoSection;

  const tripOptions = data?.tripOptions;
  const analytics = (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_1__/* .getAnalytics */ .I)();
  const upcomingTrip = travelFormInfo?.upcomingTrip;
  const travelNameRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(null); // Read defaults from URL

  const urlParams = new URLSearchParams( true ? window.location.search : 0);
  const urlTravellerCount = urlParams.get("travellers");
  const urlStartDate = urlParams.get("startDate") || query?.startDate;
  const urlEndDate = urlParams.get("endDate") || query?.endDate;
  let urlCountries = urlParams.get("countries") || query?.countries;

  if (countryCode && seoPageType === "COUNTRY") {
    urlCountries = countryCode || "";
  }

  const travellerCountDefault = ({
    defaultCount
  } = {}) => {
    if (urlTravellerCount || defaultCount) {
      return Number(urlTravellerCount || defaultCount);
    } else if (prePopulatedData) {
      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("travellers", prePopulatedData?.travellerNum.toString());
      return prePopulatedData?.travellerNum;
    } else if (upcomingTrip?.travellerNum) {
      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("travellers", upcomingTrip.travellerNum.toString());
      return Number(upcomingTrip.travellerNum);
    } else {
      return travelFormInfo?.traveller?.defaultValue || 1;
    }
  }; // Parse dates from URL if present


  const parsedStartDate = urlStartDate ? (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertUnixToDate */ .P9)(parseInt(urlStartDate)) : null;
  const parsedEndDate = urlEndDate ? (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertUnixToDate */ .P9)(parseInt(urlEndDate)) : null;
  const defaultTripOption = urlParams.get("tripOption") || query?.tripOption || prePopulatedData?.tripOption?.toUpperCase() || null;
  const {
    0: selectedTripOption,
    1: setSelectedTripOption
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(defaultTripOption); // Parse countries from URL if present

  let urlCountryCodes = urlCountries ? urlCountries.split(",") : [];
  const selectedTripOptionObject = tripOptions?.find(option => option.id === selectedTripOption);

  const getDefaultPlanTypeId = () => {
    if (selectedTripOptionObject?.planTypes) {
      return urlParams.get("planType") || query?.planType || prePopulatedData?.planType || "";
    }

    return "";
  };

  const defaultPlanTypeId = getDefaultPlanTypeId();
  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    if (selectedTripOption) {
      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("tripOption", selectedTripOption);
    } else {
      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistoryRemoveParams */ ._A)("tripOption");
    }

    if (defaultPlanTypeId) {
      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("planType", defaultPlanTypeId);
    } else {
      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistoryRemoveParams */ ._A)("planType");
    }
  }, [defaultPlanTypeId, selectedTripOption]);
  const countryList = isCommonLandingRevamp ? selectedTripOptionObject?.countryList : travelFormInfo?.countryList;
  const initialCountryStateData = (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .getInitialCountryData */ .aB)(countryList?.value, urlCountryCodes, upcomingTrip, prePopulatedData, isCommonLandingRevamp, selectedTripOption);
  const placeHolder = countryList?.placeholder || "You can select multiple destinations";
  const countrySelectErrMsg = countryList?.error_message || "Please select a country";
  const travellerSelectErrMsg = travelFormInfo?.errors?.no_travellers || "Please select number of travellers";
  const dateSelectErrMsg = travelFormInfo?.errors?.no_dates || "Please select start and end dates";
  const {
    0: showCountry,
    1: setShowCountry
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)([]);
  const buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(null);
  const {
    0: isCountryError,
    1: setIsCountryError
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
  const {
    0: formCountryErrorMsg,
    1: setFormCountryErrorMsg
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(""); // const [formAgeErrorMsg, setFormAgeErrorMsg] = useState("");

  const {
    0: formTravellerErrorMsg,
    1: setFormTravellerErrorMsg
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)("");
  const {
    0: formDateErrorMsg,
    1: setFormDateErrorMsg
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)("");
  const {
    0: formValidationToastMsg,
    1: setFormValidationToastMsg
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)("");
  let toastTimeout = null;
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(null);
  const {
    0: bottomSheetShowCount,
    1: setBottomSheetShowCount
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(0);
  const bottomSheetShowCountRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(0);
  const {
    0: showTravellerDropdown,
    1: setShowTravellerDropdown
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
  const {
    0: travellerCount,
    1: setTravellerCount
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(travellerCountDefault({
    defaultCount: query?.travellers
  }));
  const travellerDropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(null);
  const {
    0: isUserLoggedIn,
    1: setIsUserLoggedIn
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(true); // const [travAgeRange, setTravAgeRange] = useState<any[]>([{}]);
  // const [captureCount, setCaptureCount] = useState<number>(travellerCount);

  const {
    0: focusedIndex,
    1: setFocusedIndex
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(-1); // const [ageRangeSelectIndex, setAgeRangeSelectIndex] = useState<number>(-1);
  // const [isAgeRangeSelectedError, setIsAgeRangeSelectedError] =
  //   useState<boolean>(false);

  const lastCalendarTypeSingleRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(""); // const ageRangeSelectRef = useRef<HTMLDivElement>(null);

  const travellingToRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(null);
  const {
    0: countryData,
    1: setCountryData
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(initialCountryStateData || []);
  const {
    0: showInfoModal,
    1: setShowInfoModal
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(null);
  const {
    0: showDropOffModal,
    1: setShowDropOffModal
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(showOnLand);
  const {
    0: showCalendarPersuasionModal,
    1: setShowCalendarPersuasionModal
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
  const hasUserInteractedRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(false);
  const segmentsObject = isCommonLandingRevamp ? selectedTripOptionObject?.planTypes : travelFormInfo?.segments;
  const segments = segmentsObject?.value; // Find default segment with proper null checks

  const selectedDefaultSegment = segments && segments.length > 0 ? segments.find(segment => segment.isSelected) : null;
  let defaultSegmentQuery = query?.segment;

  if (seoPageType === "SEGMENT" && segmentId) {
    defaultSegmentQuery = segmentId;
  }

  const defaultSegmentInfo = segments && segments.length > 0 && defaultSegmentQuery ? segments.find(segment => segment.id === defaultSegmentQuery) : selectedDefaultSegment;
  const defaultPlanType = isCommonLandingRevamp ? selectedTripOptionObject?.planTypes?.value?.find(plan => plan.id === defaultPlanTypeId) : null;
  const defaultSegment = isCommonLandingRevamp ? defaultPlanType : defaultSegmentInfo;
  const {
    0: selectedSegment,
    1: setSelectedSegment
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(defaultSegment);
  const {
    0: selectedSegmentId,
    1: setSelectedSegmentId
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(defaultSegment?.id || null);
  const {
    0: segmentModalHandled,
    1: setSegmentModalHandled
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
  const lastCalendarTypeRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)("");
  const previousCalendarTypeRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(null);
  const calenderSelectionType = isCommonLandingRevamp ? selectedTripOptionObject?.calenderSelectionType : selectedSegment?.calenderSelectionType;

  const validateDropOffModalInvocation = () => {
    if (showDropOffModal) {
      return;
    }

    const dropOffBottomSheet = data?.dropOffBottomSheet; // Early return if dropOffBottomSheet is not configured or should show on land

    if (!dropOffBottomSheet || dropOffBottomSheet.showOnLand === true) {
      return;
    } // Don't show dropOffBottomSheet if user has interacted


    if (dropOffBottomSheet.isInteractionEnable === true && hasUserInteractedRef.current) {
      return;
    } // Check if previous page should hide the bottom sheet


    const previousPage = _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_4__/* .pageStack.getPreviousPage */ .Nq.getPreviousPage();

    if (Array.isArray(dropOffBottomSheet.excludePagesList) && dropOffBottomSheet.excludePagesList.includes(previousPage)) {
      return;
    }

    const canShowBottomSheet = dropOffBottomSheet.counter === undefined || bottomSheetShowCountRef.current < dropOffBottomSheet.counter;

    if (canShowBottomSheet) {
      setShowDropOffModal(true);

      if (dropOffBottomSheet.counter !== undefined) {
        bottomSheetShowCountRef.current += 1;
        setBottomSheetShowCount(bottomSheetShowCountRef.current);
      }
    } else {
      return;
    }

    setShowDropOffModal(true);
  }; // const loadAgeRangesFromUrl = () => {
  //   if (
  //     !travellerInfoSection?.travellerInfoSelectSection?.ageRangeSection
  //       ?.ageRanges
  //   ) {
  //     return;
  //   }
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const urlTravellerCount = urlParams.get("travellers");
  //   const urlTravellerAgeRanges = urlParams.get("travellerAgeRanges");
  //   if (!urlTravellerAgeRanges) {
  //     return;
  //   }
  //   try {
  //     const decodedAgeRanges = decodeURIComponent(urlTravellerAgeRanges);
  //     const ageRangeIndices = JSON.parse(decodedAgeRanges);
  //     if (!Array.isArray(ageRangeIndices)) {
  //       console.error("Invalid travellerAgeRanges format");
  //       return;
  //     }
  //     const availableAgeRanges =
  //       travellerInfoSection.travellerInfoSelectSection.ageRangeSection
  //         .ageRanges;
  //     let travellerNum = urlTravellerCount ? parseInt(urlTravellerCount) : 1;
  //     if (travellerInfoSection && ageRangeIndices.length < travellerNum) {
  //       travellerNum = ageRangeIndices.length;
  //       setTravellerCount(travellerNum);
  //       setCaptureCount(travellerNum);
  //       replaceHistory("travellers", travellerNum.toString());
  //     }
  //     const newTravAgeRange = Array(travellerNum).fill({});
  //     ageRangeIndices.forEach((index, arrayIndex) => {
  //       if (arrayIndex < newTravAgeRange.length && availableAgeRanges[index]) {
  //         newTravAgeRange[arrayIndex] = {
  //           ...availableAgeRanges[index],
  //           key: index,
  //           value: [
  //             availableAgeRanges[index].min,
  //             availableAgeRanges[index].max,
  //           ],
  //         };
  //       }
  //     });
  //     setTravAgeRange(newTravAgeRange);
  //   } catch (error) {
  //     console.error("Error parsing travellerAgeRanges from URL:", error);
  //   }
  // };


  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_4__/* .pageStack.push */ .Nq.push(_tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_4__/* .PAGE_NAME_CONSTANTS.COMMON_LANDING */ .X_.COMMON_LANDING);
    analytics?.trackCommonLandingEvents({
      actionType: `upcoming_trips_${upcomingTrip ? "present" : "absent"}|url_data_${urlStartDate ? "present" : "absent"}`
    });

    if (isCommonLandingRevamp && tripOptions) {
      tripOptions.forEach(option => {
        analytics?.trackCommonLandingEvents({
          actionType: `${option.id}_seen`
        });
      });
    }

    if (countryCode && seoPageType === "COUNTRY") {
      urlCountries = countryCode || "";
      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("countries", urlCountries);
    }

    const checkLoginStatus = () => {
      const userToken = localStorage.getItem("userToken");
      setIsUserLoggedIn(!!userToken);
    };

    const handleMouseLeave = event => {
      if (event.clientY <= 0) {
        validateDropOffModalInvocation();
      }
    };

    document.addEventListener("mouseout", handleMouseLeave);
    checkLoginStatus();

    if (calenderSelectionType === "SINGLE") {
      lastCalendarTypeSingleRef.current = calenderSelectionType;
      lastCalendarTypeRef.current = true;
    }

    if (defaultSegment?.calenderSelectionType === "SINGLE") {
      lastCalendarTypeSingleRef.current = defaultSegment?.calenderSelectionType;
      lastCalendarTypeRef.current = true;
    } // return () => {
    //   document.removeEventListener("mouseout", handleMouseLeave);
    // };

  }, []); // useEffect(() => {
  //   if (
  //     travellerInfoSection?.travellerInfoSelectSection?.ageRangeSection
  //       ?.ageRanges
  //   ) {
  //     loadAgeRangesFromUrl();
  //   }
  // }, [travellerInfoSection]);
  // const handleClickOutside = (event: Event) => {
  //   if (ref?.current && !ref?.current?.contains(event.target as Node)) {
  //     setFocusedIndex(-1);
  //     setShowToast(false);
  //   }
  //   if (
  //     ageRangeSelectRef?.current &&
  //     !ageRangeSelectRef?.current?.contains(event.target as Node)
  //   ) {
  //     setAgeRangeSelectIndex(-1);
  //   }
  // };
  // const handleWindowScroll = (e: any) => {
  //   if (ageRangeSelectRef.current) {
  //     const rect = ageRangeSelectRef.current.getBoundingClientRect();
  //     if (
  //       e.target !== ageRangeSelectRef.current &&
  //       (window.scrollY < rect.top || window.scrollY > rect.bottom)
  //     ) {
  //       setAgeRangeSelectIndex(-1);
  //     }
  //   }
  // };
  // useEffect(() => {
  //   document.addEventListener("click", handleClickOutside, false);
  //   document.addEventListener("scroll", handleWindowScroll, false);
  //   return () => {
  //     document.removeEventListener("click", handleClickOutside, false);
  //     document.removeEventListener("scroll", handleWindowScroll, false);
  //   };
  // }, []);

  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    if (!showTravellerDropdown) return;
    let timeout = null;

    if (showTravellerDropdown) {
      timeout = setTimeout(() => {
        const selectedElement = document.querySelector('[data-selected="true"]');

        if (selectedElement) {
          selectedElement.scrollIntoView({
            block: "center",
            behavior: "auto"
          });
        }
      }, 0);
    }

    function handleClickOutside(event) {
      if (travellerDropdownRef.current && !travellerDropdownRef.current.contains(event.target)) {
        setShowTravellerDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      if (timeout) clearTimeout(timeout);
    };
  }, [showTravellerDropdown]);
  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    if (focusedIndex !== 3) return;

    function handleClickOutside(event) {
      if (travellingToRef.current && !travellingToRef.current.contains(event.target)) {
        setFocusedIndex(-1);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [focusedIndex]);
  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    const button = buttonRef.current;
    let viewportMargin = 16;
    let searchBarOffset = 60;

    if (button) {
      const rect = button.getBoundingClientRect();
      const offsetTop = window.scrollY + rect.top;
      const isInViewport = offsetTop >= 0 && offsetTop + rect.height <= window.innerHeight - viewportMargin;

      if (!isInViewport) {
        const scrollPosition = offsetTop - window.innerHeight + rect.height + viewportMargin + searchBarOffset;
        window.scrollTo({
          top: scrollPosition,
          behavior: "smooth"
        });
      }
    }
  }, [showCountry]);

  const handleDescriptionModal = country => {
    const clickedTime = (0,_tm_utility__WEBPACK_IMPORTED_MODULE_8__/* .getSessionStorageItem */ .St)("clickedTime") ? (0,_tm_utility__WEBPACK_IMPORTED_MODULE_8__/* .getSessionStorageItem */ .St)("clickedTime") : {};
    const currentTime = new Date().getTime();
    const code = country.code;

    if (!clickedTime[country.code] || currentTime - parseInt(clickedTime[country.code], 10) >= 1800000) {
      clickedTime[code] = currentTime.toString();
      (0,_tm_utility__WEBPACK_IMPORTED_MODULE_8__/* .setSessionStorageItem */ .D9)("clickedTime", _objectSpread({}, clickedTime));
      return country.description;
    }

    return "";
  };

  const {
    0: isSegmentModalShown,
    1: setIsSegmentModalShown
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
  const {
    0: isTripOptionModalShown,
    1: setIsTripOptionModalShown
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
  const {
    0: tripOptionModalHandled,
    1: setTripOptionModalHandled
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
  const {
    0: openCalendar,
    1: setOpenCalendar
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(null); // Ref for detecting clicks outside the calendar

  const startCalendarDropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(null);
  const endCalendarDropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    function handleClickOutside(event) {
      if (openCalendar === "start" && startCalendarDropdownRef.current && !startCalendarDropdownRef.current.contains(event.target)) {
        setOpenCalendar(null);
      }

      if (openCalendar === "end" && endCalendarDropdownRef.current && !endCalendarDropdownRef.current.contains(event.target)) {
        setOpenCalendar(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openCalendar]);

  const getCalendarDatesLimit = () => {
    if (isCommonLandingRevamp) {
      let config = selectedTripOptionObject?.config;

      if (selectedTripOptionObject?.planTypes && selectedSegment?.config) {
        config = selectedSegment?.config || selectedTripOptionObject?.planTypes?.value?.find(plan => plan.id === defaultPlanTypeId)?.config;
      }

      if (config) {
        return config;
      }
    }

    if (selectedSegment?.config) {
      return selectedSegment.config;
    }

    if (defaultSegment?.config) {
      return defaultSegment.config;
    }

    return data?.pageInfo?.calendarDatesLimit || {};
  };

  const getDateDiffInDays = (date1, date2) => {
    const diff = Math.abs(date2.getTime() - date1.getTime());
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
  };

  const calendarDatesLimit = getCalendarDatesLimit();
  const {
    endDateErrorMessage,
    insPurchaseDateLimitInDays,
    insPurchaseEndDateLimitInDays,
    insPurchaseStartDateLimitInDays,
    insPurchaseStartDateMinLimitInDays,
    startDateErrorMessage,
    insPurchaseEndDateMinLimitInDays,
    durationAllowed
  } = calendarDatesLimit; // Extract durationAllowed from selectedSegment config if it exists
  // const durationAllowed = selectedSegment?.config?.durationAllowed;
  // Check if single calendar selection type is enabled

  const isSingleDate = calenderSelectionType === "SINGLE";

  function getCurrentCalendarConfig() {
    // 1. Check for exclusive country
    const exclusiveCountry = countryData?.find(c => c.isExclusiveSelection && c.isSelected && c.config && c.config.calendar);

    if (exclusiveCountry) {
      return exclusiveCountry.config.calendar;
    } // 2. Check for selected segment


    if (selectedSegment && selectedSegment.config) {
      return selectedSegment.config;
    } // 3. Fallback to global


    return data?.pageInfo?.calendarDatesLimit || {};
  }

  const defaultStartDate = () => {
    if (parsedStartDate) return parsedStartDate;

    if (prePopulatedData?.travelDuration?.startDate) {
      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("startDate", prePopulatedData.travelDuration.startDate.toString());
      return (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertUnixToDate */ .P9)(parseInt(prePopulatedData.travelDuration.startDate));
    } else if (upcomingTrip?.travelDuration?.startDate) {
      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("startDate", upcomingTrip?.travelDuration?.startDate.toString());
      return (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertUnixToDate */ .P9)(parseInt(upcomingTrip?.travelDuration?.startDate));
    } else {
      return (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)((0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .getIndiaTodayDate */ .pu)(), insPurchaseStartDateMinLimitInDays);
    }
  };

  const defaultEndDate = () => {
    if (parsedEndDate) return parsedEndDate;else if (prePopulatedData?.travelDuration?.endDate) {
      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("endDate", prePopulatedData.travelDuration.endDate.toString());
      return (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertUnixToDate */ .P9)(parseInt(prePopulatedData.travelDuration.endDate));
    } else if (upcomingTrip?.travelDuration?.endDate) {
      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("endDate", upcomingTrip?.travelDuration?.endDate.toString());
      return (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertUnixToDate */ .P9)(parseInt(upcomingTrip?.travelDuration?.endDate));
    } else {
      const baseDate = parsedStartDate ? parsedStartDate : (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .getIndiaTodayDate */ .pu)();
      const daysToAdd = isSingleDate && durationAllowed ? durationAllowed : insPurchaseEndDateMinLimitInDays;
      return (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(baseDate, daysToAdd);
    }
  };

  const defaultSelected = {
    from: defaultStartDate(),
    to: defaultEndDate()
  };
  const {
    0: range,
    1: setRange
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(defaultSelected);
  const {
    0: showToast,
    1: setShowToast
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
  const {
    0: toastMessage,
    1: setToastMessage
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)("");
  const {
    0: showDateChangeToast,
    1: setShowDateChangeToast
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
  const {
    0: dateChangeToastMessage,
    1: setDateChangeToastMessage
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    if (!range?.from) return;
    const queryParams = new URLSearchParams(window.location.search);
    const startDateParam = queryParams.get("startDate");
    const endDateParam = queryParams.get("endDate"); // Use existing start date from state, or fall back to URL param, or default

    let newFromDate;

    if (range?.from) {
      newFromDate = range.from;
    } else if (startDateParam) {
      newFromDate = (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertUnixToDate */ .P9)(parseInt(startDateParam));
    } else {
      const fallbackDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(new Date(), insPurchaseStartDateMinLimitInDays);
      newFromDate = fallbackDate || new Date();
    }

    if (isCommonLandingRevamp) {
      // NEW LOGIC: For common landing revamp
      // Check if we're switching FROM SINGLE calendar type TO non-SINGLE
      const wasSingleCalendar = previousCalendarTypeRef.current === "SINGLE";
      const isNowSingleCalendar = calenderSelectionType === "SINGLE" && durationAllowed;
      const switchingFromSingleToNonSingle = wasSingleCalendar && !isNowSingleCalendar;
      let toDate;

      if (isNowSingleCalendar) {
        // For SINGLE calendar type with durationAllowed (e.g., MULTITRIP)
        toDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(newFromDate, durationAllowed) || newFromDate;
      } else if (switchingFromSingleToNonSingle) {
        // Only recalculate when switching FROM SINGLE to non-SINGLE
        toDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(newFromDate, insPurchaseEndDateMinLimitInDays) || newFromDate;
      } else {
        // Keep existing end date for other cases
        if (range?.to) {
          toDate = range.to;
        } else if (endDateParam) {
          toDate = (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertUnixToDate */ .P9)(parseInt(endDateParam));
        } else {
          toDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(newFromDate, insPurchaseEndDateMinLimitInDays) || newFromDate;
        }
      } // Show toast if end date changed


      if (toDate && range?.to && (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(toDate, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.DATE_FORMATS["DD/MM/YYYY"]) !== (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(range?.to, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.DATE_FORMATS["DD/MM/YYYY"])) {
        setShowDateChangeToast(true);
        const hydratedSegment = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .hydrateVars */ .iX)(selectedSegment?.toast?.message, {
          END_DATE: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(toDate, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.DATE_FORMATS["DD MMM YYYY"])
        });
        setDateChangeToastMessage(hydratedSegment);
      } // Update URL and state


      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("startDate", (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(newFromDate).toString());
      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("endDate", (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(toDate).toString());
      setRange({
        from: newFromDate,
        to: toDate
      }); // Update the ref to track current calendar type

      previousCalendarTypeRef.current = isNowSingleCalendar ? "SINGLE" : "NON_SINGLE";
    } else {
      const minThresholdDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)((0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .getIndiaTodayDate */ .pu)(), insPurchaseStartDateMinLimitInDays);
      let fromDate = minThresholdDate;

      if (fromDate && calenderSelectionType === "SINGLE" && durationAllowed) {
        if (startDateParam) {
          fromDate = (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertUnixToDate */ .P9)(parseInt(startDateParam));
        }

        const toDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(fromDate, durationAllowed);

        if (toDate && range?.to && (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(toDate, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.DATE_FORMATS["DD/MM/YYYY"]) !== (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(range?.to, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.DATE_FORMATS["DD/MM/YYYY"])) {
          setShowDateChangeToast(true);
          const hydratedSegment = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .hydrateVars */ .iX)(selectedSegment?.toast?.message, {
            END_DATE: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(toDate, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.DATE_FORMATS["DD MMM YYYY"])
          });
          setDateChangeToastMessage(hydratedSegment);
        }

        if (fromDate) {
          (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("startDate", (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(fromDate).toString());
        }

        if (toDate) {
          (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("endDate", (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(toDate).toString());
        }

        setRange({
          from: fromDate,
          to: toDate
        });
      } else {
        if (startDateParam) {
          fromDate = (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertUnixToDate */ .P9)(parseInt(startDateParam));
        }

        let toDate = fromDate ? (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(fromDate, insPurchaseEndDateMinLimitInDays) : (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)((0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .getIndiaTodayDate */ .pu)(), insPurchaseEndDateMinLimitInDays);

        if (endDateParam && !lastCalendarTypeRef.current) {
          toDate = (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertUnixToDate */ .P9)(parseInt(endDateParam));
        }

        if (lastCalendarTypeRef.current && fromDate) {
          toDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(fromDate, insPurchaseEndDateMinLimitInDays);
        }

        if (toDate && range?.to && (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(toDate, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.DATE_FORMATS["DD/MM/YYYY"]) !== (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(range?.to, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.DATE_FORMATS["DD/MM/YYYY"])) {
          setShowDateChangeToast(true);
          const hydratedSegment = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .hydrateVars */ .iX)(selectedSegment?.toast?.message, {
            END_DATE: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(toDate, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.DATE_FORMATS["DD MMM YYYY"])
          });
          setDateChangeToastMessage(hydratedSegment);
        }

        if (fromDate) {
          (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("startDate", (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(fromDate).toString());
        }

        if (toDate) {
          (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("endDate", (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(toDate).toString());
        }

        setRange({
          from: fromDate,
          to: toDate
        });
      }
    }
  }, [selectedSegment, selectedTripOption]);
  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    if (showDateChangeToast) {
      setTimeout(() => {
        setShowDateChangeToast(false);
      }, 3000);
    }
  }, [showDateChangeToast]); // Helper functions for DayPicker

  const weekDayNameFormatter = date => {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("span", {
      "data-test-id": "CommonLandingDT-weekDayNameFormatter",
      children: date.toDateString()[0]
    });
  };

  const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const monthNameFormatter = date => {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)("span", {
      "data-test-id": "CommonLandingDT-monthNameFormatter",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("b", {
        "data-test-id": "CommonLandingDT-monthNameFormatter-b",
        children: MONTHS[date.getMonth()]
      }), "\xA0", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("span", {
        children: date.getFullYear().toString().slice(-2)
      })]
    });
  };

  const disabledDays = date => {
    const minDays = typeof insPurchaseStartDateMinLimitInDays === "number" ? insPurchaseStartDateMinLimitInDays : 0; // Set both dates to midnight for accurate comparison

    const today = (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .getIndiaTodayDate */ .pu)();
    today.setHours(0, 0, 0, 0);
    const minSelectableDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(today, minDays) || today;
    minSelectableDate.setHours(0, 0, 0, 0);
    const compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0);
    if (compareDate < minSelectableDate) return true;

    if (openCalendar === "end" && range?.from) {
      const fromDate = new Date(range.from);
      fromDate.setHours(0, 0, 0, 0);
      if (compareDate < fromDate) return true;
    }

    return !!(maxEndDate && compareDate > maxEndDate);
  };

  const {
    0: currentMonth,
    1: setCurrentMonth
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)((0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .getIndiaTodayDate */ .pu)());

  const handleMonthChange = month => {
    setCurrentMonth(month);
  };

  const maxEndDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)((0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .getIndiaTodayDate */ .pu)(), insPurchaseDateLimitInDays);
  const {
    0: dateTab,
    1: setDateTab
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(0);
  const {
    0: tempRange,
    1: setTempRange
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)({
    from: undefined,
    to: undefined
  });
  const popularCountryData = initialCountryStateData.filter(country => country.isPopular);
  const {
    0: showOtherCountry,
    1: setOtherCountry
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
  const {
    0: popularCountries,
    1: setPopularCountries
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(popularCountryData || []);

  const handleSingleDateSelect = selectedDate => {
    // Validate selected date is not null/undefined and is a valid date
    if (!selectedDate || isNaN(selectedDate.getTime())) {
      console.error("Invalid date selected:", selectedDate);
      return;
    } // Validate selected date against max start date


    const maxStartDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)((0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .getIndiaTodayDate */ .pu)(), insPurchaseStartDateLimitInDays);

    if (maxStartDate && maxStartDate < selectedDate) {
      setShowToast(true);
      setToastMessage(startDateErrorMessage);
      return;
    } // Auto-calculate end date based on business logic


    let autoEndDate;

    if (durationAllowed && isSingleDate) {
      // For multi-trip, use the duration allowed from selected date
      autoEndDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(selectedDate, durationAllowed) || selectedDate;
    } else if (isSingleDate && !durationAllowed) {
      // For last segment with calenderType SINGLE, always calculate endDate from startDate + insPurchaseEndDateMinLimitInDays
      autoEndDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(selectedDate, insPurchaseEndDateMinLimitInDays) || selectedDate;
    } else {
      // For single trip, use the minimum end date limit from selected date
      autoEndDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(selectedDate, insPurchaseEndDateMinLimitInDays) || selectedDate;
    } // Validate auto-calculated end date


    if (!autoEndDate || isNaN(autoEndDate.getTime())) {
      console.error("Invalid auto-calculated end date:", autoEndDate); // Final fallback - add 1 day using addDaysToDate

      autoEndDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(selectedDate, 1) || selectedDate;
    } // Validate auto-calculated end date against max end date


    const maxAllowedEndDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)((0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .getIndiaTodayDate */ .pu)(), insPurchaseDateLimitInDays);

    if (maxAllowedEndDate && maxAllowedEndDate < autoEndDate) {
      // If auto-calculated end date exceeds limit, set to max allowed
      autoEndDate = maxAllowedEndDate;
    } // Check if end date is changing and show toast


    if (range?.to && (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(autoEndDate, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.DATE_FORMATS["DD/MM/YYYY"]) !== (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(range.to, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.DATE_FORMATS["DD/MM/YYYY"])) {
      setShowDateChangeToast(true);
      const hydratedSegment = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .hydrateVars */ .iX)(selectedSegment?.toast?.message, {
        END_DATE: (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(autoEndDate, _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.DATE_FORMATS["DD MMM YYYY"])
      });
      setDateChangeToastMessage(hydratedSegment);
    } // Set the date range with auto-calculated end date


    setRange({
      from: selectedDate,
      to: autoEndDate
    });
    setShowToast(false); // Update URL history

    (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("startDate", (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(selectedDate).toString());
    (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("endDate", (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(autoEndDate).toString()); // Track analytics

    analytics?.trackCommonLandingEvents({
      actionType: "date_selected",
      payload: `single_date: ${selectedDate.toISOString()}`
    });
    (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "date_selected:single_date"
      }
    }, {
      fromDateTime: (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(selectedDate),
      toDateTime: (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(autoEndDate)
    }); // Auto-close calendar

    setOpenCalendar(null);
    setDateTab(0); // Reset to start date tab for next time

    if (!travellerCount) {
      setShowTravellerDropdown(true);
    }
  };

  const handleDayClick = selectedDate => {
    if (openCalendar === "start") {
      if (dateTab === 0) {
        const maxStartDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(new Date(), insPurchaseStartDateLimitInDays);

        if (maxStartDate && maxStartDate < selectedDate) {
          setShowToast(true);
          setToastMessage(startDateErrorMessage);
        } else {
          setTempRange({
            from: selectedDate,
            to: undefined
          });
          setDateTab(1);
          setShowToast(false);
        }
      } else if (dateTab === 1) {
        if (tempRange.from) {
          if (selectedDate < tempRange.from) {
            setTempRange({
              from: selectedDate,
              to: undefined
            });
            (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__.updateSearchContext)({
              fromDateTime: (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(selectedDate)
            });
            setShowToast(false);
            setDateTab(1);
          } else {
            const fromDate = new Date(tempRange.from);
            const maxEndDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(fromDate, insPurchaseEndDateLimitInDays);

            if (maxEndDate && maxEndDate < selectedDate) {
              setShowToast(true);
              setToastMessage(endDateErrorMessage);
            } else {
              setRange({
                from: tempRange.from,
                to: selectedDate
              });
              (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__.updateSearchContext)({
                fromDateTime: (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(tempRange.from),
                toDateTime: (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(selectedDate)
              });
              (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("startDate", (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(tempRange.from).toString());
              (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("endDate", (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(selectedDate).toString());
              setShowToast(false);
              setDateTab(0);
              setTempRange({
                from: undefined,
                to: undefined
              });
              setOpenCalendar(null);

              if (!travellerCount) {
                setShowTravellerDropdown(true);
              }

              if (getDateDiffInDays(tempRange.from, selectedDate) > minDurationDaysForCalendarPersuasion) {
                setShowCalendarPersuasionModal(true);
              }
            }
          }
        }
      }
    } else if (openCalendar === "end") {
      if (range?.from) {
        if (selectedDate < range.from) {
          setRange({
            from: selectedDate,
            to: undefined
          });
          (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__.updateSearchContext)({
            fromDateTime: (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(selectedDate)
          });
          (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("startDate", (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(selectedDate).toString());
          (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("endDate", "");
          setShowToast(false);
        } else {
          const fromDate = new Date(range?.from);
          const maxEndDate = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .addDaysToDate */ .Xz)(fromDate, insPurchaseEndDateLimitInDays);

          if (maxEndDate && maxEndDate < selectedDate) {
            setShowToast(true);
            setToastMessage(endDateErrorMessage);
          } else {
            setRange({
              from: range?.from,
              to: selectedDate
            });
            (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__.updateSearchContext)({
              fromDateTime: (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(range?.from),
              toDateTime: (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(selectedDate)
            });
            setShowToast(false);
            (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("endDate", (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(selectedDate).toString());
            setOpenCalendar(null);

            if (!travellerCount) {
              setShowTravellerDropdown(true);
            }

            if (getDateDiffInDays(range?.from, selectedDate) > minDurationDaysForCalendarPersuasion) {
              setShowCalendarPersuasionModal(true);
            }
          }
        }
      }
    }

    analytics?.trackCommonLandingEvents({
      actionType: "date_selected",
      payload: `${openCalendar}: ${selectedDate.toISOString()}`
    });
    (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "date_selected:multi_date"
      }
    });
  }; // Helper functions for date formatting


  const formatDay = date => {
    return date ? date.getDate().toString().padStart(2, "0") : "--";
  };

  const formatMonthYear = date => {
    if (!date) return "--";
    const month = date.toLocaleString("en-US", {
      month: "short"
    });
    const year = date.getFullYear().toString().slice(-2);
    return `${month} '${year}`;
  };

  const formatDayName = date => date ? date.toLocaleString("en-US", {
    weekday: "long"
  }) : "--";

  const travelFormContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_12__.useRef)(null);
  const {
    0: ctaStyle,
    1: setCtaStyle
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)({
    position: "absolute",
    left: "50%",
    transform: "translate(-50%, 50%)",
    bottom: 0,
    width: "312px"
  });
  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    function updateCTAButtonPosition() {
      const container = travelFormContainerRef.current;

      if (container) {
        const rect = container.getBoundingClientRect();
        const buttonHeight = 48;
        setCtaStyle({
          position: "absolute",
          left: "50%",
          transform: "translate(-50%, 50%)",
          bottom: 0,
          width: "312px"
        });
      }
    }

    updateCTAButtonPosition();
    window.addEventListener("resize", updateCTAButtonPosition);
    return () => window.removeEventListener("resize", updateCTAButtonPosition);
  }, []); // Set default segment from URL or first isSelected

  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    let segParam = queryParams.get("segment");

    if (seoPageType === "SEGMENT" && segmentId) {
      segParam = segmentId;
    }

    const planTypeParam = queryParams.get("planType");
    let defaultSegment = null;

    if (segments && segments.length > 0) {
      // First, check if we're returning from MULTITRIP with saved segment
      if (isCommonLandingRevamp && tempUserData?.planType && selectedTripOption !== "MULTITRIP") {
        defaultSegment = segments.find(item => item.id == tempUserData.planType);
      } // Then check URL params


      if (!defaultSegment && isCommonLandingRevamp) {
        defaultSegment = segments.find(item => item.id == planTypeParam);
      } else if (!defaultSegment && segParam) {
        defaultSegment = segments.find(item => item.id == segParam);
      } // Finally, fallback to default


      if (!defaultSegment) {
        defaultSegment = segments.find(item => item.isSelected) || segments[0];
      }

      if (defaultSegment) {
        setSelectedSegmentId(defaultSegment.id);
        setSelectedSegment(defaultSegment);
        (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("segment", defaultSegment.id);
      }
    } else {
      // If no segments available, reset to null
      setSelectedSegmentId(null);
      setSelectedSegment(null);
    }
  }, [JSON.stringify(segments), selectedTripOption]);
  const {
    0: tempUserData,
    1: setTempUserData
  } = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)({
    planType: selectedSegmentId,
    countries: urlCountryCodes.join(",")
  });
  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    if (isCommonLandingRevamp && selectedTripOption !== "MULTITRIP") {
      urlCountryCodes = tempUserData?.countries ? tempUserData?.countries.split(",") : urlCountryCodes;

      if (tempUserData?.countries) {
        (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("countries", tempUserData?.countries);
      }
    }

    if (countryList?.value) {
      const initialCountryData = (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .getInitialCountryData */ .aB)(countryList?.value, urlCountryCodes, upcomingTrip, prePopulatedData, isCommonLandingRevamp, selectedTripOption);

      if (urlCountryCodes.length === 0 && prePopulatedData?.countryCode && prePopulatedData.countryCode.length > 0) {
        (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("countries", prePopulatedData.countryCode.join(","));
      }

      if (urlCountryCodes.length === 0 && upcomingTrip?.countryCode) {
        (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("countries", upcomingTrip?.countryCode);
      }

      setCountryData(initialCountryData);
      const popularCountryData = initialCountryData.filter(country => country.isPopular);
      setPopularCountries(popularCountryData);
    }
  }, [travelFormInfo, selectedTripOption, countryList?.value]);

  const handleShowOtherCountry = () => {
    hasUserInteractedRef.current = true;

    if (!showOtherCountry) {
      // Create a map of popular country selections for quick lookup
      const popularCountrySelections = new Map(popularCountries?.map(c => [c.code, c.isSelected]) || []);
      let countryDataArr = countryData?.map(country => {
        // For popular countries, use selection from popularCountries (to sync user interactions)
        // For non-popular countries, preserve the original selection from countryData (to keep URL selections)
        const isPopularCountry = popularCountrySelections.has(country.code);
        const isSelected = isPopularCountry ? popularCountrySelections.get(country.code) : country.isSelected;
        return _objectSpread(_objectSpread({}, country), {}, {
          isSelected: isSelected || false,
          isDisabled: false,
          keywords: typeof country?.keywords === "string" ? country.keywords.split(",").map(keyword => keyword.trim()) : country?.keywords
        });
      });
      const isExclusiveCountrySelected = countryDataArr.find(item => item.isExclusiveSelection && item.isSelected);
      countryDataArr = countryDataArr?.map(country => {
        if (isExclusiveCountrySelected) {
          return country.isExclusiveSelection ? _objectSpread({}, country) : _objectSpread(_objectSpread({}, country), {}, {
            isSelected: false,
            isDisabled: true
          });
        } else if (countryDataArr.some(item => item.isSelected)) {
          return country.isExclusiveSelection ? _objectSpread(_objectSpread({}, country), {}, {
            isDisabled: true
          }) : _objectSpread({}, country);
        }

        return _objectSpread({}, country);
      });
      const selectedRegionCodes = countryDataArr.filter(data => data.isSelected && data.type === "REGION").map(data => data.code);
      selectedRegionCodes?.map(code => {
        countryDataArr = countryDataArr.map(country => {
          if (country.regionCodes && country.regionCodes.includes(code)) {
            return _objectSpread(_objectSpread({}, country), {}, {
              isDisabled: true
            });
          }

          return _objectSpread({}, country);
        });
      });
      setCountryData(countryDataArr);
    }

    if (showOtherCountry) {
      if (!range?.from) {
        setOpenCalendar("start");
      } else if (!travellerCount) {
        setShowTravellerDropdown(true);
      }
    }

    setOtherCountry(!showOtherCountry);
  };

  const extractCountryCount = countryCount => {
    if (countryCount) {
      return parseInt(countryCount.split(" ")[0]);
    }

    return 0;
  };

  const selectedCountriesInfo = react__WEBPACK_IMPORTED_MODULE_12__.useMemo(() => {
    const selectedCountries = countryData.filter(country => country.isSelected && !country.isDisabled);
    const selectedRegions = [];
    const selectedIndividualCountries = [];
    selectedCountries.forEach(country => {
      if (country.type === "REGION") {
        selectedRegions.push(country);
      } else {
        selectedIndividualCountries.push(country);
      }
    });
    let displayText = "";
    let subText = "";

    if (selectedCountries.length > 0) {
      const displayNames = selectedCountries.slice(0, 3).map(c => c.name + (c.subtitle || ""));
      displayText = displayNames.join(", ");

      if (selectedCountries.length > 3) {
        displayText += `, +${selectedCountries.length - 3}`;
      }

      let totalCountriesCoveredCount = selectedIndividualCountries.length;

      if (selectedRegions.length > 0) {
        selectedRegions.forEach(region => {
          totalCountriesCoveredCount += extractCountryCount(region?.countryCount);
        });
      }

      subText = `${totalCountriesCoveredCount} ${totalCountriesCoveredCount === 1 ? "country" : "countries"}`;
    } else {
      displayText = "Select destinations";
      subText = "Click to select countries";
    }

    return {
      displayText,
      subText,
      selectedCountries
    };
  }, [countryData]); // Clear country error if a country is selected

  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    if (selectedCountriesInfo.selectedCountries.length > 0) {
      setIsCountryError(false);
      setFormCountryErrorMsg("");
    }

    if (travellerCount) {
      setFormTravellerErrorMsg("");
    }

    if (range?.from && range?.to) {
      setFormDateErrorMsg("");
    }
  }, [selectedCountriesInfo.selectedCountries, travellerCount, range]); // const getAgeRanges = (travAgeRange: any[]) => {
  //   let ageRanges = travAgeRange.map((ageRange: any) => {
  //     return ageRange?.label?.text?.value;
  //   });
  //   var ageRangesStr = ageRanges.join(", ");
  //   if (ageRangesStr.length > 25) {
  //     return ageRangesStr.substring(0, 25) + "...";
  //   } else {
  //     return ageRangesStr;
  //   }
  // };
  // Segment select handler with country check and toast logic

  const handleSegmentSelect = segment => {
    hasUserInteractedRef.current = true;

    if (segment && segment.id) {
      setSelectedSegmentId(segment.id);
      setSelectedSegment(segment);
      (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("segment", segment.id); // Set lastCalendarTypeSingle based on segment's calenderSelectionType

      if (calenderSelectionType === "SINGLE") {
        lastCalendarTypeSingleRef.current = calenderSelectionType;
        lastCalendarTypeRef.current = true;
      } else {
        if (lastCalendarTypeSingleRef.current === "SINGLE") {
          lastCalendarTypeRef.current = true;
          lastCalendarTypeSingleRef.current = segment.id;
        } else {
          lastCalendarTypeRef.current = false;
        }
      }

      (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__.trackEvent)({
        event_detail: {
          event_type: "action",
          event_name: "component_cta-clicked",
          event_value: "segment_clicked"
        }
      }, {
        journeyType: segment.id?.toLowerCase() || ""
      });
      analytics?.trackCommonLandingEvents({
        actionType: "segment_clicked",
        payload: segment.name
      });
    }
  };

  const nextPageDataCallTrigger = async requestData => {
    try {
      const response = await (0,_tm_insurance_api__WEBPACK_IMPORTED_MODULE_3__/* .getNextPageRouteDetails */ .$P)(requestData);
      const {
        responseStatus,
        nextPageRouteConfig
      } = response;

      if (responseStatus === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.RESPONSE_STATUS.SUCCESS) {
        if (nextPageRouteConfig?.type === "external_link") {
          window.open(nextPageRouteConfig?.route, "_blank");
        } else {
          let route = nextPageRouteConfig?.route;

          if (route.startsWith("/insurance") && !location.pathname.includes("/travel-insurance")) {
            route = route.replace("/insurance", "");
          }

          _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_4__/* .navigationActions.navigateToPageByRouteName */ .ej.navigateToPageByRouteName(route);
        }
      }
    } catch (err) {
      console.error("NEXT PAGE ROUTE FAILURE ERROR ----", {
        err
      });
      const {
        error
      } = err?.response?.data || {};
      throw new _tm_utility__WEBPACK_IMPORTED_MODULE_8__/* .ClientError */ .XF(error);
    }
  };

  const nextPageRouteCall = async () => {
    let searchParams = new URLSearchParams(window.location.search);
    let countries = searchParams.get("countries");

    if (isCommonLandingRevamp && selectedTripOption === "MULTITRIP") {
      if (countries?.includes("USA") || countries?.includes("CAN") || countries?.includes("WW")) countries = "WW";else countries = "WWEUC";
    }

    const countryCodes = countries ? countries.split(",") : [];
    const selectedPopCountries = (popularCountries ?? []).filter(country => countryCodes?.includes(country.code)).map(item => item.name).join("|");
    analytics?.trackCommonLandingEvents({
      actionType: "popular_country_selected",
      payload: selectedPopCountries
    } //"click"
    );
    analytics?.trackCommonLandingEvents({
      actionType: "explore_plan_click"
    } //"click"
    );
    (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "explore_plan_click"
      }
    });
    (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__.triggerPageExit)();

    if (range && travellerCount && countryCodes?.length) {
      const selectedSegmentIdV2 = isCommonLandingRevamp ? selectedTripOption === "MULTITRIP" ? "MULTITRIP" : selectedSegmentId : selectedSegmentId || "";
      const requestData = {
        query: {
          itineraryId: new URLSearchParams(window.location.search).get("itineraryId") || "",
          source: "standalone_regular" // source: data?.travellerInfoSection
          //   ? "standalone_retail"
          //   : "standalone_regular",

        },
        partner: _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_6__.PARTNER.MMT,
        userSearchIntent: _objectSpread({
          country: countryCodes,
          departureDateTime: (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(range.from || (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .getIndiaTodayDate */ .pu)()),
          arrivalDateTime: range.to ? (0,_utils__WEBPACK_IMPORTED_MODULE_13__/* .convertDateToUnix */ .cJ)(range.to) : Number(searchParams.get("endDate")),
          numberOfTravellers: travellerCount,
          segment: selectedSegmentIdV2
        }, isCommonLandingRevamp && {
          planType: selectedSegmentId,
          tripOption: selectedTripOption
        })
      };
      nextPageDataCallTrigger(requestData);
    }
  };

  const onSubmit = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const countries = searchParams.get("countries");
    const countryCodes = countries ? countries.split(",") : [];

    if (!countryCodes || countryCodes.length === 0 || !countryCodes[0]) {
      setIsCountryError(true);
      setFormCountryErrorMsg(countrySelectErrMsg || "Please select a country");
      analytics?.trackCommonLandingEvents?.({
        actionType: "error_shown",
        payload: countrySelectErrMsg || "Please select a country"
      });
      (0,libs_utility_src_lib_analytics_XDMAnalytics_xdmEvents__WEBPACK_IMPORTED_MODULE_10__/* .errorTrackEvent */ .t1)({
        error_details_list: [{
          message: countrySelectErrMsg || "Please select a country",
          source: "country_select",
          severity: "P3"
        }]
      });
    } // if (travellerInfoSection) {
    //   let hasValidAgeRanges =
    //     travAgeRange &&
    //     travAgeRange.length === travellerCount &&
    //     travAgeRange.every(
    //       (range) => range && range.value && range.value.length === 2
    //     );
    //   if (!hasValidAgeRanges) {
    //     setIsAgeRangeSelectedError(true);
    //     setFormAgeErrorMsg(
    //       travellerInfoSection.selectError ||
    //       "Please select age ranges for all travelers"
    //     );
    //     analytics?.trackCommonLandingEvents?.({
    //       actionType: "error_shown",
    //       payload:
    //         travellerInfoSection.selectError ||
    //         "Please select age ranges for all travelers",
    //     });
    //     errorTrackEvent({
    //       error_details_list: [
    //         {
    //           error_message:
    //             travellerInfoSection.selectError ||
    //             "Please select age ranges for all travelers",
    //           error_source: "travellerInfoSection",
    //           error_severity: 3,
    //         },
    //       ],
    //     });
    //   }
    // }


    if (selectedSegment && selectedSegment?.id && selectedSegment.id === "STUDENT" && countryCodes[0] === "IN") {
      setFormValidationToastMsg("We do not have domestic student plans, please select another country to see student plans");
      if (toastTimeout) clearTimeout(toastTimeout);
      toastTimeout = setTimeout(() => {
        setFormValidationToastMsg("");
      }, 3000);
      analytics?.trackCommonLandingEvents?.({
        actionType: "error_shown",
        payload: "We do not have domestic student plans, please select another country to see student plans"
      });
      (0,libs_utility_src_lib_analytics_XDMAnalytics_xdmEvents__WEBPACK_IMPORTED_MODULE_10__/* .errorTrackEvent */ .t1)({
        error_details_list: [{
          message: "We do not have domestic student plans, please select another country to see student plans",
          source: "student_plan",
          severity: "P3"
        }]
      });
      return;
    }

    (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("segment", selectedSegmentId?.toString() || "");

    if (!range?.from || !range?.to) {
      setFormDateErrorMsg(dateSelectErrMsg || "Please select start and end dates");
    }

    if (!travellerCount) {
      setFormTravellerErrorMsg(travellerSelectErrMsg || "Please select number of travellers");
    }

    if (range?.from && range?.to && travellerCount && countryCodes.length) {
      if (isCommonLandingRevamp && selectedTripOption && selectedTripOptionObject.modal && !tripOptionModalHandled) {
        setIsTripOptionModalShown(true);
        setTripOptionModalHandled(true);
        return;
      }

      if (selectedSegment && selectedSegment.modal && !segmentModalHandled) {
        setIsSegmentModalShown(true);
        setSegmentModalHandled(true);
        return;
      }

      (0,_tm_utility_analytics__WEBPACK_IMPORTED_MODULE_15__/* .storePageTransitionStart */ .SE)("landing");
      nextPageRouteCall();
    }

    analytics?.trackCommonLandingEvents({
      actionType: "explore_clicked"
    });
  }; // Track ProductOfferBanner shown


  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    if (travelFormInfo?.productOfferBanner) {
      analytics?.trackCommonLandingEvents({
        actionType: "productOfferBanner_shown"
      });
      (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__.trackComponentView)({
        name: "productOfferBanner_shown",
        type: "card"
      });
    }
  }, [travelFormInfo?.productOfferBanner]); // Track Persuasion shown

  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    if (travelFormInfo?.persuasion) {
      analytics?.trackCommonLandingEvents({
        actionType: "persuasion_shown"
      });
      (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__.trackComponentView)({
        name: "persuasion_shown",
        type: "card"
      });
    }
  }, [travelFormInfo?.persuasion]); // Track Segments shown

  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    if (segments?.length) {
      analytics?.trackCommonLandingEvents({
        actionType: "segments_shown"
      });
      (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__.trackComponentView)({
        name: "segments_shown",
        type: "card"
      });
    }
  }, [segments]); // Track Travel Plans section shown and plans shown

  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    if (data?.travelProtection?.plans?.length) {
      analytics?.trackCommonLandingEvents({
        actionType: "travelPlans_shown",
        payload: data.travelProtection.plans.map(p => p.title).join(",")
      });
      (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__.trackComponentView)({
        name: "travelPlans_shown",
        type: "card"
      });
    }
  }, [data?.travelProtection?.plans]); // Track OfferedBy shown

  (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(() => {
    if (data?.pageInfo?.offeredBy) {
      analytics?.trackCommonLandingEvents({
        actionType: "offeredBy_shown",
        payload: data.pageInfo.offeredBy.title?.text?.value
      });
      (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__.trackComponentView)({
        name: "offeredBy_shown",
        type: "card"
      });
    }
  }, [data?.pageInfo?.offeredBy]); // Add a useEffect to clear the age error when all age ranges are selected
  // useEffect(() => {
  //   if (
  //     travellerInfoSection &&
  //     travAgeRange &&
  //     travAgeRange.length === travellerCount &&
  //     travAgeRange.every(
  //       (range) => range && range.value && range.value.length === 2
  //     )
  //   ) {
  //     setIsAgeRangeSelectedError(false);
  //     setFormAgeErrorMsg("");
  //   }
  // }, [travAgeRange, travellerCount, travellerInfoSection]);

  const handleTripOptionChange = id => {
    hasUserInteractedRef.current = true;

    if (id === "MULTITRIP") {
      // Save planType and countries when switching to MULTITRIP
      setTempUserData({
        planType: selectedSegmentId,
        countries: urlCountryCodes.join(",")
      });
    }

    (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("tripOption", id);
    setSelectedTripOption(id);
  };

  const getInfoModalData = id => {
    const option = tripOptions.find(option => option.id === id);

    if (option) {
      return option.bottomSheetData;
    }

    return null;
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .TravelFormWrapper */ .TW, {
      ref: ref,
      "data-test-id": "CommonLandingDT-TravelFormWrapper",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .TravelFormContainer */ .bk, {
        ref: travelFormContainerRef,
        style: {
          position: "relative"
        },
        "data-test-id": "CommonLandingDT-TravelFormContainer",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .FormHeader */ .ph, {
          "data-test-id": "CommonLandingDT-FormHeader",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .FormHeaderFlex */ .Cf, {
            "data-test-id": "CommonLandingDT-FormHeaderFlex",
            children: [isCommonLandingRevamp && tripOptions && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .TripOptionsContainer */ .Y$, {
              "data-test-id": "CommonLandingDT-TripOptionsContainer",
              children: tripOptions.map(option => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .RadioItem */ .Rk, {
                isSelected: selectedTripOption === option.id,
                "data-test-id": "CommonLandingDT-RadioItem",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.TickRadioComp, {
                  inputId: option.id,
                  isSelected: selectedTripOption === option.id,
                  onClick: () => {
                    analytics?.trackCommonLandingEvents({
                      actionType: `${option.id}_clicked`
                    });
                    handleTripOptionChange(option.id);
                  },
                  "data-test-id": "CommonLandingDT-TickRadioComp",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.FormattedText, {
                    value: option.name,
                    "data-test-id": "CommonLandingDT-FormattedText"
                  }), option.icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .IconContainer */ .qk, {
                    onClick: e => {
                      analytics?.trackCommonLandingEvents({
                        actionType: `${option.id}_info_clicked`
                      });
                      hasUserInteractedRef.current = true;
                      setShowInfoModal(option.id);
                      e.stopPropagation();
                      e.preventDefault();
                    },
                    "data-test-id": "CommonLandingDT-IconContainer",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.ImageComponent, {
                      src: option.icon,
                      width: "16px",
                      height: "16px",
                      alt: "Offer",
                      "data-test-id": "CommonLandingDT-ImageComponent"
                    })
                  }), option.tagImg && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.ImageComponent, {
                    src: option.tagImg,
                    width: "27px",
                    height: "auto",
                    alt: "Offer",
                    "data-test-id": "CommonLandingDT-ImageComponent"
                  })]
                })
              }, option.id))
            }), travelFormInfo?.productOfferBanner && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .ProductBanner */ .EP, {
              isRevamp: isCommonLandingRevamp,
              "data-test-id": "CommonLandingDT-ProductBanner",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .BannerIcon */ .u1, {
                isRevamp: isCommonLandingRevamp,
                "data-test-id": "CommonLandingDT-BannerIcon",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.ImageComponent, {
                  src: travelFormInfo.productOfferBanner.icon,
                  width: "24px",
                  height: "24px",
                  alt: "Offer",
                  "data-test-id": "CommonLandingDT-ImageComponent"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .BannerContent */ .y, {
                isRevamp: isCommonLandingRevamp,
                "data-test-id": "CommonLandingDT-BannerContent",
                children: travelFormInfo.productOfferBanner && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.FormattedText, {
                  value: travelFormInfo.productOfferBanner.title,
                  "data-test-id": "CommonLandingDT-FormattedText"
                })
              }), travelFormInfo?.productOfferBanner?.info?.icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .TrailingBannerIcon */ .v, {
                onClick: () => {
                  analytics?.trackCommonLandingEvents({
                    actionType: "persuasion_info_icon_clicked"
                  });
                  hasUserInteractedRef.current = true;
                  window.open(travelFormInfo.productOfferBanner.info?.url, "_blank");
                },
                "data-test-id": "CommonLandingDT-TrailingBannerIcon",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.ImageComponent, {
                  src: travelFormInfo.productOfferBanner.info.icon,
                  width: "16px",
                  height: "16px",
                  alt: "Offer",
                  "data-test-id": "CommonLandingDT-ImageComponent"
                })
              })]
            }), travelFormInfo?.persuasion && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .PersuasionText */ .NA, {
              "data-test-id": "CommonLandingDT-PersuasionText",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.FormattedText, {
                value: travelFormInfo.persuasion,
                "data-test-id": "CommonLandingDT-FormattedText"
              })
            })]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .FormContent */ .fb, {
          "data-test-id": "CommonLandingDT-FormContent",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .FormSection */ .hj, {
            style: {
              cursor: "pointer",
              position: "relative",
              backgroundColor: `${showOtherCountry ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_9__/* .theme.lightBlueBg */ .rS.lightBlueBg : ""}`
            },
            "data-test-id": "CommonLandingDT-FormSection",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)("div", {
              ref: travelNameRef,
              onClick: handleShowOtherCountry,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .LabelWithIcon */ .E6, {
                "data-test-id": "CommonLandingDT-LabelWithIcon",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .Label */ .__, {
                  style: {
                    color: `${showOtherCountry ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_9__/* .theme.blueText */ .rS.blueText : ""}`
                  },
                  "data-test-id": "CommonLandingDT-Label",
                  children: countryList?.label || "TRAVELLING TO"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .ArrowIcon */ .e0, {
                  src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
                  alt: "View toggle icon",
                  isRotated: showOtherCountry,
                  "data-test-id": "CommonLandingDT-ArrowIcon"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .MainText */ .zr, {
                "data-test-id": "CommonLandingDT-MainText",
                children: selectedCountriesInfo.displayText
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .SubText */ .i_, {
                "data-test-id": "CommonLandingDT-SubText",
                children: selectedCountriesInfo.subText
              })]
            }), showOtherCountry && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(SelectCountryModalV2, {
              countryData: countryData,
              popularCountries: popularCountries,
              handleSelectCountry: handleShowOtherCountry,
              setCountryData: setCountryData,
              setShowCountry: setShowCountry,
              showCountry: showCountry,
              setIsCountryError: setIsCountryError,
              setPopularCountries: setPopularCountries,
              customSubTitle: placeHolder,
              countrySelectErrMsg: countrySelectErrMsg,
              handleDescriptionModal: handleDescriptionModal,
              focusSearchOnOpen: true,
              isDropdown: true,
              travelNameRef: travelNameRef,
              "data-test-id": "CommonLandingDT-SelectCountryModalV2"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .Divider */ .iz, {
            "data-test-id": "CommonLandingDT-Divider"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .FormSection */ .hj, {
            onClick: () => {
              hasUserInteractedRef.current = true;
              setTempRange(range ?? {
                from: undefined,
                to: undefined
              });
              setOpenCalendar(openCalendar === "start" ? null : "start");
            },
            style: {
              backgroundColor: `${openCalendar === "start" ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_9__/* .theme.lightBlueBg */ .rS.lightBlueBg : ""}`
            },
            "data-test-id": "CommonLandingDT-FormSection",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .LabelWithIcon */ .E6, {
              "data-test-id": "CommonLandingDT-LabelWithIcon",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .Label */ .__, {
                style: {
                  color: `${openCalendar === "start" ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_9__/* .theme.blueText */ .rS.blueText : ""}`
                },
                "data-test-id": "CommonLandingDT-Label",
                children: travelFormInfo?.travelDate?.start?.label
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .ArrowIcon */ .e0, {
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
                alt: "View toggle icon",
                isRotated: openCalendar === "start",
                "data-test-id": "CommonLandingDT-ArrowIcon"
              })]
            }), range?.from ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.Fragment, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .MainText */ .zr, {
                "data-test-id": "CommonLandingDT-MainText",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .DateNumber */ .kc, {
                  "data-test-id": "CommonLandingDT-DateNumber",
                  children: formatDay(range?.from)
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .DateMonthYear */ .kI, {
                  "data-test-id": "CommonLandingDT-DateMonthYear",
                  children: formatMonthYear(range?.from)
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .SubText */ .i_, {
                "data-test-id": "CommonLandingDT-SubText",
                children: formatDayName(range?.from)
              })]
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .MainText */ .zr, {
              "data-test-id": "CommonLandingDT-MainText",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.FormattedText, {
                value: travelFormInfo?.travelDate?.start?.placeHolder,
                "data-test-id": "CommonLandingDT-FormattedText"
              })
            }), openCalendar === "start" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(CalendarDropdown, {
              calendarRef: startCalendarDropdownRef,
              isSingleDate: isSingleDate,
              selectedSegment: selectedSegment,
              showToast: showToast,
              toastMessage: toastMessage,
              range: range,
              tempRange: tempRange,
              openCalendar: openCalendar,
              disabledDays: disabledDays,
              handleSingleDateSelect: handleSingleDateSelect,
              handleDayClick: handleDayClick,
              weekDayNameFormatter: weekDayNameFormatter,
              monthNameFormatter: monthNameFormatter,
              currentMonth: currentMonth,
              handleMonthChange: handleMonthChange,
              "data-test-id": "CommonLandingDT-CalendarDropdown"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .Divider */ .iz, {
            "data-test-id": "CommonLandingDT-Divider"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .FormSection */ .hj, {
            onClick: () => {
              hasUserInteractedRef.current = true;

              if (!isSingleDate) {
                if (openCalendar === "end") {
                  setOpenCalendar(null);
                } else if (!range?.from) {
                  setOpenCalendar("start");
                } else {
                  setOpenCalendar("end");
                }
              }
            },
            style: {
              cursor: isSingleDate ? "not-allowed" : "pointer",
              opacity: isSingleDate ? 0.5 : 1,
              backgroundColor: `${openCalendar === "end" ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_9__/* .theme.lightBlueBg */ .rS.lightBlueBg : ""}`
            },
            "data-test-id": "CommonLandingDT-FormSection",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .LabelWithIcon */ .E6, {
              "data-test-id": "CommonLandingDT-LabelWithIcon",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .Label */ .__, {
                style: {
                  color: `${openCalendar === "end" ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_9__/* .theme.blueText */ .rS.blueText : ""}`
                },
                "data-test-id": "CommonLandingDT-Label",
                children: travelFormInfo?.travelDate?.end?.label
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .ArrowIcon */ .e0, {
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
                alt: "View toggle icon",
                isRotated: openCalendar === "end",
                style: {
                  opacity: isSingleDate ? 0.5 : 1
                },
                "data-test-id": "CommonLandingDT-ArrowIcon"
              })]
            }), range?.to ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.Fragment, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .MainText */ .zr, {
                "data-test-id": "CommonLandingDT-MainText",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .DateNumber */ .kc, {
                  "data-test-id": "CommonLandingDT-DateNumber",
                  children: formatDay(range?.to)
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .DateMonthYear */ .kI, {
                  "data-test-id": "CommonLandingDT-DateMonthYear",
                  children: formatMonthYear(range?.to)
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .SubText */ .i_, {
                "data-test-id": "CommonLandingDT-SubText",
                children: [formatDayName(range?.to), isSingleDate && range?.to && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("span", {
                  style: {
                    color: "#666",
                    fontSize: "12px",
                    marginLeft: "4px"
                  },
                  children: "(1 year validity)"
                })]
              })]
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .MainText */ .zr, {
              "data-test-id": "CommonLandingDT-MainText",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.FormattedText, {
                value: travelFormInfo?.travelDate?.end?.placeHolder,
                "data-test-id": "CommonLandingDT-FormattedText"
              })
            }), openCalendar === "end" && !isSingleDate && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(CalendarDropdown, {
              calendarRef: endCalendarDropdownRef,
              isSingleDate: isSingleDate,
              selectedSegment: selectedSegment,
              showToast: showToast,
              toastMessage: toastMessage,
              range: range,
              tempRange: tempRange,
              openCalendar: openCalendar,
              disabledDays: disabledDays,
              handleSingleDateSelect: handleSingleDateSelect,
              handleDayClick: handleDayClick,
              weekDayNameFormatter: weekDayNameFormatter,
              monthNameFormatter: monthNameFormatter,
              currentMonth: currentMonth,
              handleMonthChange: handleMonthChange,
              "data-test-id": "CommonLandingDT-CalendarDropdown"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .Divider */ .iz, {
            "data-test-id": "CommonLandingDT-Divider"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .FormSection */ .hj, {
            ref: travellingToRef,
            style: {
              position: "relative",
              width: "280px",
              backgroundColor: `${showTravellerDropdown ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_9__/* .theme.lightBlueBg */ .rS.lightBlueBg : ""}`
            },
            onClick: () => {
              hasUserInteractedRef.current = true; // if (!travellerInfoSection) {

              setShowTravellerDropdown(v => !v); // setAgeRangeSelectIndex(-1);
              // } else {
              //   if (focusedIndex !== 3) {
              //     setAgeRangeSelectIndex(-1);
              //   }
              //   setFocusedIndex(focusedIndex === 3 ? -1 : 3);
              // }
            },
            "data-test-id": "CommonLandingDT-FormSection",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .LabelWithIcon */ .E6, {
              "data-test-id": "CommonLandingDT-LabelWithIcon",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .Label */ .__, {
                style: {
                  color: `${showTravellerDropdown ? _tm_utility_global__WEBPACK_IMPORTED_MODULE_9__/* .theme.blueText */ .rS.blueText : ""}`
                },
                "data-test-id": "CommonLandingDT-Label",
                children: travelFormInfo?.traveller?.label || "No. of Travellers"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .ArrowIcon */ .e0, {
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg",
                alt: "View toggle icon",
                isRotated: isUserLoggedIn ? showTravellerDropdown : focusedIndex === 3,
                "data-test-id": "CommonLandingDT-ArrowIcon"
              })]
            }), travellerCount ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .MainText */ .zr, {
              "data-test-id": "CommonLandingDT-MainText",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.Fragment, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .TravellerNumber */ .q, {
                  "data-test-id": "CommonLandingDT-TravellerNumber",
                  children: travellerCount
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .TravellerText */ .G_, {
                  "data-test-id": "CommonLandingDT-TravellerText",
                  children: ["Traveller", travellerCount !== 1 ? "s" : ""]
                })]
              })
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .MainText */ .zr, {
              "data-test-id": "CommonLandingDT-MainText",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.FormattedText, {
                value: travelFormInfo?.traveller?.placeHolder,
                "data-test-id": "CommonLandingDT-FormattedText"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .SubText */ .i_, {
              "data-test-id": "CommonLandingDT-SubText",
              children: travelFormInfo?.traveller?.description
            }), showTravellerDropdown && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("div", {
              ref: travellerDropdownRef,
              style: {
                position: "absolute",
                zIndex: 10,
                background: "#fff",
                width: "100%",
                left: 0,
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                borderRadius: "8px",
                padding: "8px 0",
                top: "100%",
                maxHeight: "240px",
                overflowY: "auto"
              },
              onClick: e => e.stopPropagation(),
              children: Array.from({
                length: 20
              }, (_, i) => i + 1).map(num => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("div", {
                "data-selected": travellerCount === num,
                style: {
                  padding: "12px 16px",
                  textAlign: "center",
                  fontSize: "16px",
                  cursor: "pointer",
                  fontWeight: travellerCount === num ? 700 : 400,
                  color: travellerCount === num ? "#008CFF" : "#333",
                  backgroundColor: travellerCount === num ? "#f5f9ff" : "transparent"
                },
                onClick: () => {
                  setTravellerCount(num);
                  (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_5__/* .replaceHistory */ .df)("travellers", num.toString());
                  setShowTravellerDropdown(false);
                  (0,_tm_insurance_analytics_xdm__WEBPACK_IMPORTED_MODULE_2__.updateSearchContext)({
                    travellers: num
                  });
                },
                children: num <= 9 ? `0${num}` : num
              }, num))
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)("div", {
          style: {
            display: "flex",
            justifyContent: "space-between"
          },
          children: [formCountryErrorMsg ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .ErrorSpan */ .gk, {
            "data-test-id": "CommonLandingDT-ErrorSpan",
            children: formCountryErrorMsg
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("span", {
            style: {
              height: "12px",
              width: "12px"
            }
          }), formDateErrorMsg ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .ErrorSpan */ .gk, {
            "data-test-id": "CommonLandingDT-ErrorSpan",
            children: formDateErrorMsg
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("span", {
            style: {
              height: "12px",
              width: "12px"
            }
          }), formTravellerErrorMsg ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .ErrorSpan */ .gk, {
            "data-test-id": "CommonLandingDT-ErrorSpan",
            children: formTravellerErrorMsg
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("span", {
            style: {
              height: "12px",
              width: "12px"
            }
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.FlexComp, {
          justifyContent: "space-between",
          "data-test-id": "CommonLandingDT-FlexComp",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .SegmentFlexContainer */ .Uj, {
            "data-test-id": "CommonLandingDT-SegmentFlexContainer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .SegmentMainContainer */ ._R, {
              "data-test-id": "CommonLandingDT-SegmentMainContainer",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .SegmentWrapper */ .Wb, {
                "data-test-id": "CommonLandingDT-SegmentWrapper",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .LabelWrapper */ .ub, {
                  "data-test-id": "CommonLandingDT-LabelWrapper",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .Label */ .__, {
                    "data-test-id": "CommonLandingDT-Label",
                    children: segmentsObject?.label
                  }), segmentsObject?.badge && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .Badge */ .Ct, {
                    bgColor: segmentsObject.badge.bgColor,
                    "data-test-id": "CommonLandingDT-Badge",
                    children: segmentsObject.badge.text
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .SegmentContainer */ .SI, {
                  "data-test-id": "CommonLandingDT-SegmentContainer",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .SegmentOptions */ .vO, {
                    "data-test-id": "CommonLandingDT-SegmentOptions",
                    children: segments && segments.length > 0 && segments.map(segment => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .SegmentButton */ .bh, {
                      selected: selectedSegmentId === segment.id,
                      onClick: () => handleSegmentSelect(segment),
                      "data-test-id": "CommonLandingDT-SegmentButton",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .CheckboxContainer */ .tp, {
                        "data-test-id": "CommonLandingDT-CheckboxContainer",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .Checkbox */ .XZ, {
                          type: "radio",
                          id: `segment-${segment.id}`,
                          name: "segment-option",
                          checked: selectedSegmentId === segment.id,
                          onChange: () => handleSegmentSelect(segment),
                          "data-test-id": "CommonLandingDT-Checkbox"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .CheckboxLabel */ .ke, {
                          htmlFor: `segment-${segment.id}`,
                          "data-test-id": "CommonLandingDT-CheckboxLabel"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsxs)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .SegmentContent */ .Dd, {
                        "data-test-id": "CommonLandingDT-SegmentContent",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .SegmentHeader */ .mb, {
                          selected: selectedSegmentId === segment.id,
                          "data-test-id": "CommonLandingDT-SegmentHeader",
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.FormattedText, {
                            value: segment.name,
                            "data-test-id": "CommonLandingDT-FormattedText"
                          })
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .SubText */ .i_, {
                          "data-test-id": "CommonLandingDT-SubText",
                          children: segment.description
                        }), segment.tag && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .SegmentTag */ .WW, {
                          startColor: segment.tag.startColor,
                          endColor: segment.tag.endColor,
                          "data-test-id": "CommonLandingDT-SegmentTag",
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.FormattedText, {
                            value: segment.tag.title,
                            "data-test-id": "CommonLandingDT-FormattedText"
                          })
                        })]
                      })]
                    }, segment.id))
                  })
                }), formValidationToastMsg && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_Toast_WebToast__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                  toastTxt: formValidationToastMsg,
                  position: "fixed",
                  height: "46px",
                  width: "320px",
                  bottom: "100px",
                  right: "50px",
                  "data-test-id": "CommonLandingDT-WebToast"
                })]
              })
            })
          }), recentSearches && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.RecentSearches, {
            recentSearchInfo: recentSearches,
            nextPageDataCallTrigger: nextPageDataCallTrigger,
            "data-test-id": "CommonLandingDT-RecentSearches"
          })]
        }), isSegmentModalShown && selectedSegment && selectedSegment.modal && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(SegmentModal, {
          modal: selectedSegment.modal,
          onClose: () => {
            setIsSegmentModalShown(false);
            setSegmentModalHandled(false);
          },
          onPrimaryCta: onSubmit,
          onSecondaryCta: () => {
            setIsSegmentModalShown(false);
            setSegmentModalHandled(false);
          },
          "data-test-id": "CommonLandingDT-SegmentModal"
        }), isCommonLandingRevamp && isTripOptionModalShown && selectedTripOption && selectedTripOptionObject.modal && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(SegmentModal, {
          modal: selectedTripOptionObject.modal,
          onClose: () => {
            setIsTripOptionModalShown(false);
            setTripOptionModalHandled(false);
          },
          onPrimaryCta: onSubmit,
          onSecondaryCta: () => {
            setIsTripOptionModalShown(false);
            setTripOptionModalHandled(false);
          },
          "data-test-id": "CommonLandingDT-SegmentModal"
        }), dateChangeToastMessage && showDateChangeToast && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_Toast_WebToast__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
          type: "warning",
          iconUrl: selectedSegment?.toast?.iconUrl,
          toastTxt: dateChangeToastMessage,
          position: "fixed",
          toastTxtMargin: "0px 0px 0px 5px",
          color: _tm_utility_global__WEBPACK_IMPORTED_MODULE_9__/* .theme.yellowText */ .rS.yellowText,
          fontSize: "14px",
          fontWeight: "700",
          right: "50px",
          bottom: "50px",
          "data-test-id": "CommonLandingDT-WebToast"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_CommonLandingDT_style__WEBPACK_IMPORTED_MODULE_17__/* .CTAWrapper */ .yS, {
          style: {
            position: "static",
            marginTop: 20
          },
          "data-test-id": "CommonLandingDT-CTAWrapper",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)("div", {
            style: ctaStyle,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(_tm_static__WEBPACK_IMPORTED_MODULE_7__.LandingButton, {
              customTitle: "EXPLORE PLANS",
              customWidth: "312px",
              onClick: onSubmit,
              fontSize: "24px",
              letterSpacing: "0.46px",
              "data-test-id": "CommonLandingDT-LandingButton"
            })
          })
        })]
      })
    }), showInfoModal && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(InfoModal, {
      isOpen: showInfoModal !== null,
      onClose: () => setShowInfoModal(null),
      data: getInfoModalData(showInfoModal),
      onCTAClick: () => {
        handleTripOptionChange("MULTITRIP");
        setShowInfoModal(null);
      },
      "data-test-id": "CommonLandingDT-InfoModal"
    }), showDropOffModal && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(DropOffModal, {
      isOpen: showDropOffModal,
      onClose: () => setShowDropOffModal(false),
      data: data?.dropOffBottomSheet,
      onCTAClick: () => setShowDropOffModal(false),
      "data-test-id": "CommonLandingDT-DropOffModal"
    }), showCalendarPersuasionModal && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_18__.jsx)(CalendarPersuasionModal, {
      isOpen: showCalendarPersuasionModal,
      onClose: () => setShowCalendarPersuasionModal(false),
      data: data?.calendarBottomSheet,
      onPrimaryCTAClick: () => {
        handleTripOptionChange("MULTITRIP");
        setShowCalendarPersuasionModal(false);
      },
      "data-test-id": "CommonLandingDT-CalendarPersuasionModal"
    })]
  });
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CommonLandingDT);

/***/ }),

/***/ 53089:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ MyCash_MyCash)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/MyCash/MyCash.style.ts

const MyCashBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MyCashstyle__MyCashBanner",
  componentId: "re6czj-0"
})(["display:flex;align-items:center;justify-content:center;width:auto;height:75px;padding:16px 24px;border-radius:10px;position:relative;background:linear-gradient( 90deg,#ffffff 7.13%,#fff2af 27.04%,#ffdcce 68.13%,#ffffff 92.23% );"]);
const IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MyCashstyle__IconContainer",
  componentId: "re6czj-1"
})(["position:relative;display:flex;align-items:center;justify-content:center;width:98px;background-color:white;border-radius:50%;"]);
const ShieldIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MyCashstyle__ShieldIcon",
  componentId: "re6czj-2"
})(["width:100px;height:100px;background-image:url(", ");background-size:cover;background-position:center;"], props => props.iconUrl);
const CurrencySymbol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MyCashstyle__CurrencySymbol",
  componentId: "re6czj-3"
})(["position:absolute;font-size:24px;font-weight:bold;color:black;"]);
const TextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MyCashstyle__TextContainer",
  componentId: "re6czj-4"
})(["display:flex;align-items:center;margin-left:16px;width:212px;"]);
const GradientText = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "MyCashstyle__GradientText",
  componentId: "re6czj-5"
})(["font-size:20px;font-weight:bold;margin-right:8px;background:linear-gradient(90deg,#573e83,#ac6700);-webkit-background-clip:text;-webkit-text-fill-color:transparent;"]);
const TooltipContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MyCashstyle__TooltipContainer",
  componentId: "re6czj-6"
})(["position:relative;display:flex;align-items:center;"]);
const InfoIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MyCashstyle__InfoIcon",
  componentId: "re6czj-7"
})(["width:20px;height:20px;background-image:url(", ");background-size:cover;background-position:center;cursor:pointer;"], props => props.src);
const TooltipText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MyCashstyle__TooltipText",
  componentId: "re6czj-8"
})(["position:absolute;bottom:100%;left:50%;transform:translateX(-50%);width:218px;height:56px;padding:8px;background-color:black;color:white;font-size:12px;border-radius:6px;opacity:0;transition:opacity 0.3s;", ":hover &{opacity:1;}"], TooltipContainer);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/MyCash/MyCash.tsx









const MyCash = ({
  iconUrl,
  text,
  tooltip
}) => {
  const portalRef = (0,react.useRef)(null);
  const iconRef = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    portalRef.current = document.querySelector("#portal");
  }, []);
  const {
    0: tooltipPos,
    1: setTooltipPos
  } = (0,react.useState)({
    top: 0,
    left: 0
  });
  const {
    0: isHovered,
    1: setIsHovered
  } = (0,react.useState)(false);
  const device = (0,src/* useBreakpointV2 */.bU)();

  const handleMouseEnter = () => {
    if (iconRef?.current) {
      const rect = iconRef?.current.getBoundingClientRect();
      setTooltipPos({
        top: rect.bottom + window.scrollY - 35,
        // Position below icon
        left: rect.left + window.scrollX + rect.width + 15 // Center tooltip

      });
    }

    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MyCashBanner, {
    "data-test-id": "MyCash-MyCashBanner",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconContainer, {
      "data-test-id": "MyCash-IconContainer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ShieldIcon, {
        iconUrl: iconUrl,
        "data-test-id": "MyCash-ShieldIcon"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextContainer, {
      "data-test-id": "MyCash-TextContainer",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GradientText, {
        "data-test-id": "MyCash-GradientText",
        children: text?.value
      }), tooltip?.icon && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InfoIcon, {
          ref: iconRef,
          src: tooltip?.icon,
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          "data-test-id": "MyCash-InfoIcon"
        }), isHovered && portalRef?.current && /*#__PURE__*/(0,react_dom.createPortal)( /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            position: "absolute",
            top: `${tooltipPos?.top}px`,
            left: `${tooltipPos?.left}px`,
            transform: "translateX(-50%)",
            // Centering tooltip
            zIndex: 1000
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ToolTipComp, {
            handleMouseEnter: handleMouseEnter,
            handleMouseLeave: handleMouseLeave // top={`${tooltipPos.top}px`}
            // left={`${tooltipPos.left}px`}
            ,
            toolTipArrow: device === "lg" ? "left" : "bottom",
            width: "218px",
            backgroundColor: "black",
            zIndex: 10,
            "data-test-id": "MyCash-ToolTipComp",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.FormattedText, {
              value: tooltip?.description,
              "data-test-id": "MyCash-FormattedText"
            })
          })
        }), portalRef?.current)]
      })]
    })]
  });
};

/* harmony default export */ const MyCash_MyCash = (MyCash);

/***/ }),

/***/ 35722:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ PaymentFailedModal_PaymentFailedModal)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CommonModalDweb/CommonModalDweb.style.ts
var CommonModalDweb_style = __webpack_require__(39881);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PaymentFailedModal/PaymentFailedModal.style.ts


const PaymentFailedModalStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentFailedModalstyle__PaymentFailedModalStyle",
  componentId: "sc-13td3ir-0"
})(["", "{background:#fcdadb;}", "{background:#fcdadb;}"], CommonModalDweb_style/* CommonModalDwebStyle */.E5, CommonModalDweb_style/* CommonModalHeader */.fm);
const PaymentFailedNote = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PaymentFailedModalstyle__PaymentFailedNote",
  componentId: "sc-13td3ir-1"
})(["background:#ffffff;border-radius:8px;padding:20px;margin-bottom:26px;display:flex;flex-direction:column;gap:10px;"]);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/PaymentFailedModal/PaymentFailedModal.tsx








const PaymentFailedModal = ({
  title,
  info,
  noteTitle,
  noteInfo,
  retryBtnTxt,
  backBtnTxt,
  handleRetry,
  handleBack
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PaymentFailedModalStyle, {
    "data-test-id": "PaymentFailedModal-PaymentFailedModalStyle",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(components.CommonModalDweb, {
      errorModal: true,
      handleClick: handleBack,
      customTitle: title,
      customIcon: "https://tripmoneycmsimgak.mmtcdn.com/img/caution_Img_09e830be76.svg",
      "data-test-id": "PaymentFailedModal-CommonModalDweb",
      children: [info && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
        margin: "0 0 10px",
        fontSize: "md",
        color: Global/* theme.greyText */.rS.greyText,
        "data-test-id": "PaymentFailedModal-ParaTag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
          value: info,
          "data-test-id": "PaymentFailedModal-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PaymentFailedNote, {
        "data-test-id": "PaymentFailedModal-PaymentFailedNote",
        children: [noteTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SpanTag, {
          fontWeight: "bold",
          fontSize: "large",
          "data-test-id": "PaymentFailedModal-SpanTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: noteTitle,
            "data-test-id": "PaymentFailedModal-FormattedText"
          })
        }), noteInfo && /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
          "data-test-id": "PaymentFailedModal-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: noteInfo,
            "data-test-id": "PaymentFailedModal-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(components.FlexComp, {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "10px",
        "data-test-id": "PaymentFailedModal-FlexComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components.LandingButton, {
          customWidth: "fit-content",
          customTitle: retryBtnTxt,
          onClick: handleRetry,
          "data-test-id": "PaymentFailedModal-LandingButton"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components.AnchorTag, {
          textTransform: "uppercase",
          fontSize: "md",
          fontWeight: "bold",
          "data-test-id": "PaymentFailedModal-AnchorTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: backBtnTxt,
            "data-test-id": "PaymentFailedModal-FormattedText"
          })
        })]
      })]
    })
  });
};

/* harmony default export */ const PaymentFailedModal_PaymentFailedModal = (PaymentFailedModal);

/***/ }),

/***/ 85544:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ ProductInfoSection_ProductInfoSection)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/EducationModal/EducationModal.tsx + 1 modules
var EducationModal = __webpack_require__(9840);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ReactPortalComp.tsx
var ReactPortalComp = __webpack_require__(70629);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ProductInfoSection/ProductInfoSection.style.tsx

const BannerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProductInfoSectionstyle__BannerWrapper",
  componentId: "ayf9nd-0"
})(["display:flex;border:1px solid #fff;align-items:center;background:linear-gradient(90deg,#b3d6ff 0%,#eaf6ff 100%);border-radius:16px;padding:16px;gap:16px;max-width:600px;@media (max-width:768px){max-width:100%;padding:12px 16px;}"]);
const Icon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "ProductInfoSectionstyle__Icon",
  componentId: "ayf9nd-1"
})(["width:auto;height:auto;"]);
const Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProductInfoSectionstyle__Content",
  componentId: "ayf9nd-2"
})(["flex:1;display:flex;flex-direction:column;gap:4px;"]);
const Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProductInfoSectionstyle__Title",
  componentId: "ayf9nd-3"
})(["font-size:18px;font-weight:400;color:#111;display:flex;flex-wrap:wrap;align-items:center;@media (max-width:768px){font-size:14px;}"]);
const KnowMore = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "ProductInfoSectionstyle__KnowMore",
  componentId: "ayf9nd-4"
})(["font-size:16px;font-weight:500;text-decoration:none;color:#008cff;margin-top:2px;"]);
const ArrowButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProductInfoSectionstyle__ArrowButton",
  componentId: "ayf9nd-5"
})(["background-color:#3b82f6;border-radius:50%;width:24px;height:24px;display:flex;align-items:center;justify-content:center;cursor:pointer;margin-left:8px;&:hover{background-color:#2563eb;}"]);
const ArrowIcon = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
  displayName: "ProductInfoSectionstyle__ArrowIcon",
  componentId: "ayf9nd-6"
})(["width:20px;height:20px;"]);
const ArrowPath = styled_components_browser_esm/* default.path.withConfig */.ZP.path.withConfig({
  displayName: "ProductInfoSectionstyle__ArrowPath",
  componentId: "ayf9nd-7"
})(["fill:#ffffff;"]);
const KnowMoreTag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ProductInfoSectionstyle__KnowMoreTag",
  componentId: "ayf9nd-8"
})(["font-weight:bold;font-size:", ";width:fit-content;cursor:pointer;"], props => props.isMobile ? "12px" : "14px");
const MobileModalStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProductInfoSectionstyle__MobileModalStyle",
  componentId: "ayf9nd-9"
})(["position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.85);z-index:9999;display:flex;flex-direction:column;"]);
const DesktopModalContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProductInfoSectionstyle__DesktopModalContainer",
  componentId: "ayf9nd-10"
})(["position:fixed;top:0;left:0;width:100vw;height:100vh;display:flex;align-items:center;justify-content:center;z-index:1300;"]);
const Backdrop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProductInfoSectionstyle__Backdrop",
  componentId: "ayf9nd-11"
})(["position:absolute;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.5);z-index:1;"]);
const DesktopModal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProductInfoSectionstyle__DesktopModal",
  componentId: "ayf9nd-12"
})(["position:relative;z-index:2;background:#fff;border-radius:12px;box-shadow:0 4px 32px rgba(0,0,0,0.18);display:flex;flex-direction:column;aspect-ratio:42/55;height:75vh;width:auto;overflow:scroll;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/ProductInfoSection/ProductInfoSection.tsx











const FullscreenMobileModal = ({
  open,
  onClose,
  title,
  url
}) => {
  if (!open) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileModalStyle, {
    "data-test-id": "FullscreenMobileModal-MobileModalStyle",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "16px",
        background: "#fff",
        borderBottom: "1px solid #eee"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        style: {
          fontWeight: 600,
          fontSize: 16
        },
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        onClick: onClose,
        style: {
          background: "none",
          border: "none",
          fontSize: 24,
          cursor: "pointer"
        },
        children: "\xD7"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
      src: url,
      style: {
        flex: 1,
        width: "100%",
        border: "none",
        background: "#fff"
      },
      title: title || "Know More",
      allowFullScreen: true,
      "data-test-id": "FullscreenMobileModal-iframe"
    })]
  });
};

const ProductInfoSection = ({
  productInfoBanner,
  onEducationModalShown,
  onEducationModalNextClick,
  onEducationModalSkipClick,
  onEducationModalPageShown,
  onKnowMoreClick,
  onProductCardClick
}) => {
  const device = (0,src/* useBreakpointV2 */.bU)();
  const {
    0: showKnowMoreModal,
    1: setShowKnowMoreModal
  } = (0,react.useState)(false);
  const {
    0: showEducationModal,
    1: setShowEducationModal
  } = (0,react.useState)(false);
  const analytics = (0,insurance/* getAnalytics */.I)();

  const handleKnowMoreClick = e => {
    setShowKnowMoreModal(true);
    onKnowMoreClick && onKnowMoreClick();
    e.stopPropagation();
  };

  const handleClose = () => setShowKnowMoreModal(false);

  const handleEducationModalSkip = () => {
    setShowEducationModal(false);
  };

  const handleProductCardClick = () => {
    setShowEducationModal(true);
    onProductCardClick && onProductCardClick();
  };

  const isMobile = device === "sm";

  const RightArrow = ({
    color = "#FFFFFF"
  }) => /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowIcon, {
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-test-id": "ProductInfoSection-RightArrow-ArrowIcon",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowPath, {
      d: "M14.577 10.665c0-.167-.033-.32-.097-.46a1.414 1.414 0 0 0-.291-.405L7.974 3.714a1.059 1.059 0 0 0-.768-.307 1.06 1.06 0 0 0-.542.146 1.138 1.138 0 0 0-.404.396 1.032 1.032 0 0 0-.145.541c0 .302.113.566.34.792l5.536 5.383-5.537 5.382a1.103 1.103 0 0 0-.194 1.342c.103.162.237.291.405.388.167.097.347.145.541.145.302 0 .558-.102.768-.307l6.215-6.085c.134-.13.231-.264.29-.404.065-.146.098-.3.098-.461Z",
      fill: color,
      "data-test-id": "ProductInfoSection-RightArrow-ArrowPath"
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(BannerWrapper, {
      onClick: handleProductCardClick,
      "data-test-id": "ProductInfoSection-BannerWrapper",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
        src: productInfoBanner.icon,
        alt: "Product Icon",
        "data-test-id": "ProductInfoSection-Icon"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
        "data-test-id": "ProductInfoSection-Content",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          "data-test-id": "ProductInfoSection-Title",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: productInfoBanner?.title,
            "data-test-id": "ProductInfoSection-FormattedText"
          })
        }), productInfoBanner?.knowMore?.title && /*#__PURE__*/(0,jsx_runtime.jsx)(KnowMoreTag, {
          isMobile: isMobile,
          onClick: handleKnowMoreClick,
          "data-test-id": "ProductInfoSection-KnowMoreTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: productInfoBanner?.knowMore?.title,
            "data-test-id": "ProductInfoSection-FormattedText"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowButton, {
        "data-test-id": "ProductInfoSection-ArrowButton",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(RightArrow, {
          "data-test-id": "ProductInfoSection-RightArrow"
        })
      })]
    }), showKnowMoreModal && /*#__PURE__*/(0,jsx_runtime.jsx)(ReactPortalComp/* default */.Z, {
      "data-test-id": "ProductInfoSection-ReactPortalComp",
      children: isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(FullscreenMobileModal, {
        open: showKnowMoreModal,
        onClose: handleClose,
        title: typeof productInfoBanner?.knowMore?.title === "string" ? productInfoBanner?.knowMore?.title : "",
        url: productInfoBanner?.knowMore?.url,
        "data-test-id": "ProductInfoSection-FullscreenMobileModal"
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopModalContainer, {
        "data-test-id": "ProductInfoSection-DesktopModalContainer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Backdrop, {
          onClick: handleClose,
          "data-test-id": "ProductInfoSection-Backdrop"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopModal, {
          "data-test-id": "ProductInfoSection-DesktopModal",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            style: {
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: 16,
              borderBottom: "1px solid #eee"
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              style: {
                fontWeight: 600,
                fontSize: 18
              },
              children: typeof productInfoBanner?.knowMore?.title === "string" ? productInfoBanner?.knowMore?.title : ""
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              onClick: handleClose,
              style: {
                background: "none",
                border: "none",
                fontSize: 24,
                cursor: "pointer"
              },
              children: "\xD7"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
            src: productInfoBanner?.knowMore?.url,
            style: {
              flex: 1,
              width: "100%",
              height: "100%",
              border: "none",
              borderRadius: "0 0 12px 12px",
              background: "#fff"
            },
            title: typeof productInfoBanner?.knowMore?.title === "string" ? productInfoBanner?.knowMore?.title : "",
            allowFullScreen: true,
            "data-test-id": "ProductInfoSection-iframe"
          })]
        })]
      })
    }), showEducationModal && productInfoBanner && /*#__PURE__*/(0,jsx_runtime.jsx)(EducationModal/* default */.Z, {
      pagesData: productInfoBanner.pages,
      knowMore: productInfoBanner.knowMore,
      setShowEducationModal: setShowEducationModal,
      skipButtonHandler: handleEducationModalSkip,
      onModalShown: onEducationModalShown,
      onNextClick: onEducationModalNextClick,
      onSkipClick: onEducationModalSkipClick,
      onPageShown: onEducationModalPageShown,
      "data-test-id": "ProductInfoSection-EducationModal"
    })]
  });
};

/* harmony default export */ const ProductInfoSection_ProductInfoSection = (ProductInfoSection);

/***/ }),

/***/ 46299:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ QnABlock_QnABlock)
});

// EXTERNAL MODULE: ../../libs/ui/src/lib/static/constants/localData.ts
var localData = __webpack_require__(3345);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/QnABlock/QnABlock.styles.tsx


const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "QnABlockstyles__Container",
  componentId: "se7k5d-0"
})(["width:100%;background-color:", ";padding:30px 0;"], Global/* theme.darkGreyBg */.rS.darkGreyBg);
const GridContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "QnABlockstyles__GridContainer",
  componentId: "se7k5d-1"
})(["display:grid;grid-template-columns:repeat(2,1fr);gap:0;max-width:1200px;margin:0 auto;"]);
const QnaSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "QnABlockstyles__QnaSection",
  componentId: "se7k5d-2"
})(["padding:30px;", ""], props => `
        &:nth-child(n+3) {
            border-top: 1px solid #979797;
        }
    `);
const QnaBlockTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "QnABlockstyles__QnaBlockTitle",
  componentId: "se7k5d-3"
})(["font-weight:700;font-size:24px;line-height:32px;margin-bottom:20px;color:", ";max-width:1200px;margin:0 auto;padding:0 20px;"], Global/* theme.blackText */.rS.blackText);
const Question = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "QnABlockstyles__Question",
  componentId: "se7k5d-4"
})(["font-weight:700;font-size:16px;line-height:22px;margin-bottom:25px;color:", ";&::before{content:\"Q - \";color:", ";}"], Global/* theme.blackText */.rS.blackText, Global/* theme.blackText */.rS.blackText);
const Answer = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "QnABlockstyles__Answer",
  componentId: "se7k5d-5"
})(["font-size:12px;line-height:16px;color:", ";&::before{content:\"A: \";color:", ";}"], Global/* theme.greyText */.rS.greyText, Global/* theme.greyText */.rS.greyText);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/QnABlock/QnABlock.tsx





const QnABlock = ({
  data,
  qnaBlockTitle
}) => {
  const qnaData = data || localData/* LOCAL_QnA_INFO */.zF || [];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    "data-test-id": "QnABlock-Container",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(QnaBlockTitle, {
      "data-test-id": "QnABlock-QnaBlockTitle",
      children: qnaBlockTitle
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(GridContainer, {
      "data-test-id": "QnABlock-GridContainer",
      children: qnaData.map((qna, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(QnaSection, {
        index: index,
        "data-test-id": `QnABlock-QnaSection-${index}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Question, {
          "data-test-id": "QnABlock-Question",
          children: qna.ques
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Answer, {
          dangerouslySetInnerHTML: {
            __html: qna.info
          },
          "data-test-id": "QnABlock-Answer"
        })]
      }, index))
    })]
  });
};

/* harmony default export */ const QnABlock_QnABlock = (QnABlock);

/***/ }),

/***/ 39363:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": () => (/* reexport */ ComponentRenderer),
  "L": () => (/* reexport */ MYPARTNER_COMPONENT_MAPPER)
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/ComponentTransformer/utils.ts
/**
 * Shared utility functions for component transformers
 */
// Default icon mappings for benefits
const BENEFIT_ICON_MAP = {
  medical_expenses: "💊",
  trip_cancellation: "✈️",
  baggage_loss: "🧳",
  personal_liability: "🛡️",
  trip_delay: "⏱️",
  passport_loss: "📄",
  default: "✅"
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/ComponentTransformer/BenefitsTransformer.ts

/**
 * Benefits-specific API types
 */

/**
 * Transforms API benefit data into component-ready format
 */
const transformBenefits = apiBenefits => {
  return apiBenefits.map(benefit => ({
    icon: benefit.icon || {
      url: BENEFIT_ICON_MAP[benefit.id || ""] || BENEFIT_ICON_MAP["default"]
    },
    title: {
      text: {
        value: benefit.policyTitle
      }
    },
    amount: {
      text: {
        value: benefit.policyAmt
      }
    }
  }));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/ComponentTransformer/InsuranceCardsTransformer.ts


/**
 * Transforms bottomsheet data into MoreBenefits data structure
 */
const transformBottomsheetToMoreBenefits = (apiCard, insAmount, paxPerDay, buyBtn, planTitle) => {
  const bottomsheet = apiCard.benefits_info.bottomsheet;

  if (!bottomsheet) {
    throw new Error("Bottomsheet data is required for MoreBenefits transformation");
  }

  return {
    productId: apiCard.productId || "",
    quoteId: apiCard.quoteId || "",
    vendorDisplayPrefix: (typeof bottomsheet.PowerBy?.text === "object" && !Array.isArray(bottomsheet.PowerBy.text) ? bottomsheet.PowerBy.text.value : bottomsheet.PowerBy?.text) || "Powered by",
    insuranceType: bottomsheet.insPlanName,
    service: bottomsheet.disclaimer,
    planExtraInfo: undefined,
    // Not available in new structure
    packName: bottomsheet.titleDownloadBenefit,
    ctaLink: undefined,
    // Not available in new structure
    tncLink: bottomsheet.tnc?.link,
    links: [// Add T&C link if available
    ...(bottomsheet.tnc ? [{
      id: "tnc",
      title: bottomsheet.tnc.title,
      type: "link",
      url: bottomsheet.tnc.link
    }] : []), // Add download benefits dropdown if available
    ...(bottomsheet.downloadBenefitsDropdown ? [{
      id: "download_benefits",
      title: bottomsheet.downloadBenefitsDropdown.header?.title || {
        text: {
          value: "Download Benefits"
        }
      },
      type: "dropdown",
      dropdownOptions: bottomsheet.downloadBenefitsDropdown.options?.map(option => ({
        title: option.label || {
          text: {
            value: ""
          }
        },
        url: "",
        // No longer using URLs from mock data
        templateType: option.id || "with_price",
        // Use option.id as templateType
        ctaText: {
          text: {
            value: "DOWNLOAD NOW"
          }
        },
        defaultSelected: option.defaultSelected || false,
        id: option.id || `template-${option.id || "with_price"}`
      })) || []
    }] : [])],
    totalBenefits: bottomsheet.totalBenefits,
    moreBenefits: bottomsheet.moreBenefits,
    insAmount,
    paxPerDay,
    buyBtn,
    insPlanName: bottomsheet.insProvider
  };
};
/**
 * Transforms API insurance card data into InsuranceListItem props
 */

const transformInsuranceCard = (apiCard, onMoreBenefits) => {
  const transformedBenefits = transformBenefits(apiCard.benefits_info.insBenefits); // Calculate buyBtn value once

  const buyBtnValue = typeof apiCard.buyBtn === "string" ? apiCard.buyBtn : apiCard.buyBtn?.text?.value || "BUY NOW";
  const transformedCard = {
    quoteId: apiCard.quoteId,
    // Include quoteId for filtering
    productId: apiCard.productId,
    // Include productId for navigation
    logoUrl: apiCard.insIcon,
    companyName: apiCard.insProvider,
    planTitle: apiCard.insPlanName,
    discountedPrice: apiCard.insAmount,
    originalPrice: apiCard.originalPrice,
    perPersonText: apiCard.paxPerDay,
    discountText: apiCard.persuasion?.title,
    benefits: transformedBenefits,
    moreBenefitsText: {
      text: {
        value: `${apiCard.benefits_info.bottomsheet?.totalBenefits || "More Benefits"}`
      }
    },
    buyButtonText: apiCard.buyBtn,
    onMoreBenefits: onMoreBenefits ? () => onMoreBenefits(apiCard.quoteId) : undefined,
    downloadBenefitsModal: apiCard.benefits_info.downloadBenefitsModal,
    bottomsheet: apiCard.benefits_info.bottomsheet,
    insAmount: apiCard.insAmount,
    paxPerDay: apiCard.paxPerDay,
    buyBtn: buyBtnValue,
    moreBenefitsTitle: `${apiCard.benefits_info.bottomsheet?.totalBenefits || "More Benefits"}`,
    // Pre-transform MoreBenefits data to avoid inline transformation
    moreBenefitsData: apiCard.benefits_info.bottomsheet ? transformBottomsheetToMoreBenefits(apiCard, apiCard.insAmount, apiCard.paxPerDay, buyBtnValue, apiCard.insPlanName) : undefined
  };
  return transformedCard;
};
/**
 * Transforms API data into PlanCardsList props (matches ComponentMapper pattern)
 * This function returns the exact props structure that PlanCardsList expects
 */

const transformInsuranceCards = apiData => {
  const typedApiData = apiData;

  if (!typedApiData?.cards) {
    return {
      data: []
    };
  }

  const transformedCards = typedApiData.cards.map(card => {
    return transformInsuranceCard(card);
  });
  return {
    data: transformedCards
  };
};
/**
 * Transforms multiple API insurance cards with callbacks (for direct use)
 */

const transformInsuranceCardsWithCallbacks = (apiData, callbacks) => {
  return apiData.cards.map(card => transformInsuranceCard(card, callbacks?.onMoreBenefits));
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/ComponentTransformer/PassthroughTransformer.ts
/**
 * Passthrough transformers for components that don't need data transformation
 * These transformers receive API data and return it as-is
 */

/**
 * Generic passthrough transformer that returns data unchanged
 */
const passthroughTransformer = apiData => {
  return apiData;
};
/**
 * Header title transformer - passes data through unchanged
 */

const transformHeaderTitle = apiData => {
  return apiData;
};
/**
 * Filter plans transformer - passes data through unchanged
 */

const transformFilterPlans = apiData => {
  return apiData;
};
/**
 * Itinerary info transformer - extracts travelDetails from API data
 */

const transformItineraryInfo = apiData => {
  return apiData;
};
/**
 * Persuasion transformer - passes data through unchanged
 */

const transformPersuasion = apiData => {
  return apiData;
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/ComponentTransformer/types.ts

;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/ComponentTransformer/index.ts


/**
 * Component transformer mapping - maps component IDs to transformer functions
 */

const COMPONENT_TRANSFORMER = {
  HEADER_TITLE: transformHeaderTitle,
  FILTER_PLANS: transformFilterPlans,
  INSURANCE_CARDS: transformInsuranceCards,
  ITINERARY_INFO: transformItineraryInfo,
  PERSUASION: transformPersuasion
};

/* harmony default export */ const ComponentTransformer = ({
  COMPONENT_TRANSFORMER
});
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/AddTravellerDetailsComp/AddTravellerDetailsComp.tsx + 1 modules
var AddTravellerDetailsComp = __webpack_require__(80330);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/DisclaimerComp/DisclaimerComp.tsx
var DisclaimerComp = __webpack_require__(56081);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/HeaderTitleComp/HeaderTitleComp.tsx
var HeaderTitleComp = __webpack_require__(9309);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ItineraryInfoComp/ItineraryInfoComp.tsx + 1 modules
var ItineraryInfoComp = __webpack_require__(39275);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingButtonComp/LandingButtonComp.tsx + 1 modules
var LandingButtonComp = __webpack_require__(51573);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PlanPriceInfoComp/PlanPriceInfoComp.tsx + 1 modules
var PlanPriceInfoComp = __webpack_require__(3925);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PriceBreakup/PriceBreakup.tsx + 1 modules
var PriceBreakup = __webpack_require__(76827);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PrimaryContactComp/PrimaryContactComp.tsx + 1 modules
var PrimaryContactComp = __webpack_require__(3149);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TncComp/TncComp.tsx + 1 modules
var TncComp = __webpack_require__(26217);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 12 modules
var components = __webpack_require__(48359);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/mypartner/contexts/FilterContext.tsx
var FilterContext = __webpack_require__(22841);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/FilterPlans/FilterPlans.style.ts

const FilterPlansContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterPlansstyle__FilterPlansContainer",
  componentId: "sc-1m5jog6-0"
})(["background:#ffffff;border-radius:16px;padding:16px;display:flex;flex-direction:column;gap:12px;width:320px;"]);
const FilterSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterPlansstyle__FilterSection",
  componentId: "sc-1m5jog6-1"
})(["display:flex;flex-direction:column;gap:12px;"]);
const FilterTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "FilterPlansstyle__FilterTitle",
  componentId: "sc-1m5jog6-2"
})(["margin:0;font-weight:900;font-size:16px;line-height:1.2;color:rgba(0,0,0,0.85);"]);
const CheckboxItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterPlansstyle__CheckboxItem",
  componentId: "sc-1m5jog6-3"
})(["display:flex;align-items:center;gap:10px;"]);
const SumInsuredSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterPlansstyle__SumInsuredSection",
  componentId: "sc-1m5jog6-4"
})(["display:flex;flex-wrap:wrap;gap:8px;"]);
const SumInsuredButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "FilterPlansstyle__SumInsuredButton",
  componentId: "sc-1m5jog6-5"
})(["padding:8px 10px;border-radius:6px;border:1px solid ", ";background:", ";color:", ";font-weight:", ";font-size:12px;line-height:1.2;cursor:pointer;display:flex;align-items:center;justify-content:center;&:hover{border-color:#008cff;}"], props => props.isSelected ? "#008CFF" : "#E2E2E2", props => props.isSelected ? "#F8FBFF" : "#FFFFFF", props => props.isSelected ? "#008CFF" : "#4A4A4A", props => props.isSelected ? 900 : 400);
const Divider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "FilterPlansstyle__Divider",
  componentId: "sc-1m5jog6-6"
})(["height:1px;background:#f2f2f2;border:1px solid #d8d8d8;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/FilterPlans/FilterPlans.tsx





 // Define the data structure based on the mock data





const FilterPlans = ({
  filterList = []
}) => {
  const {
    currentSort,
    setSort,
    activeFilters,
    setFilter,
    setInitialFilterData
  } = (0,FilterContext/* useFilterContext */.j4)();
  const analytics = (0,insurance/* getAnalytics */.I)(); // Initialize filter data in context

  (0,react.useEffect)(() => {
    if (filterList.length > 0) {
      const filterData = filterList.map(filter => ({
        filterId: filter.key,
        title: filter.title,
        key: filter.key,
        type: filter.type,
        criteria: filter.criteria,
        enabled: false
      }));
      setInitialFilterData(filterData);
    }
  }, [filterList, setInitialFilterData]); // Handle sort filter changes

  const handleSortChange = (criteriaKey, criteriaTitle) => {
    // Use the criteria key directly - no more hardcoded mapping
    const sortKey = criteriaKey || null;
    analytics?.trackListingEvents({
      actionType: `${criteriaKey}_clicked`
    }); // For price filter, only allow single selection
    // If same sort is selected, deselect it (toggle behavior)
    // If different sort is selected, replace the current selection

    if (currentSort === sortKey) {
      setSort(null); // Deselect if clicking the same option
    } else {
      setSort(sortKey); // Select new option (automatically deselects others)
    }
  }; // Handle regular filter changes


  const handleFilterChange = (filterKey, criteriaTitle, filterType) => {
    const filterId = `${filterKey}_${criteriaTitle}`;
    const isCurrentlyActive = activeFilters[filterId] || false;
    analytics?.trackListingEvents({
      actionType: `${criteriaTitle}_filter_clicked`
    }); // No special hardcoded logic for "All" - let defaultSelected handle the behavior
    // Checkbox filters allow multi-selection
    // Radio and Button filters are single-selection

    if (filterType === "checkbox") {
      // Multi-selection: simple toggle behavior
      setFilter(filterId, !isCurrentlyActive);
    } else if (filterType === "button") {
      // Button type filters: single selection behavior
      if (!isCurrentlyActive) {
        // Selecting a new option: clear others first, then set new one
        Object.keys(activeFilters).forEach(activeFilterId => {
          if (activeFilterId.startsWith(`${filterKey}_`) && activeFilters[activeFilterId]) {
            setFilter(activeFilterId, false);
          }
        });
        setFilter(filterId, true);
      }
    } else if (filterType === "radio") {
      // Single-selection for radio filters: clear other selections first, then set new one
      Object.keys(activeFilters).forEach(activeFilterId => {
        if (activeFilterId.startsWith(`${filterKey}_`) && activeFilters[activeFilterId]) {
          setFilter(activeFilterId, false);
        }
      }); // Then set the new one (unless it was already active - toggle behavior)

      if (!isCurrentlyActive) {
        setFilter(filterId, true);
      }
    }
  }; // Check if a sort option is selected


  const isSortSelected = criteriaKey => {
    // Simply compare the criteria key with current sort
    return currentSort === criteriaKey;
  }; // Check if a filter option is selected


  const isFilterSelected = (filterKey, criteriaTitle) => {
    const filterId = `${filterKey}_${criteriaTitle}`;
    return activeFilters[filterId] || false;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(FilterPlansContainer, {
    "data-test-id": "FilterPlans-FilterPlansContainer",
    children: filterList.map((filter, filterIndex) => /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FilterSection, {
        "data-test-id": "FilterPlans-FilterSection",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FilterTitle, {
          "data-test-id": "FilterPlans-FilterTitle",
          children: filter.title.text.value
        }), filter.type === "button" ? /*#__PURE__*/(0,jsx_runtime.jsx)(SumInsuredSection, {
          "data-test-id": "FilterPlans-SumInsuredSection",
          children: filter.criteria.map((criteria, criteriaIndex) => /*#__PURE__*/(0,jsx_runtime.jsx)(SumInsuredButton, {
            isSelected: isFilterSelected(filter.key, criteria.title.text.value),
            onClick: () => handleFilterChange(filter.key, criteria.title.text.value, filter.type),
            "data-test-id": `FilterPlans-SumInsuredButton-${criteriaIndex}`,
            children: criteria.title.text.value
          }, criteriaIndex))
        }) : filter.criteria.map((criteria, criteriaIndex) => {
          if (!criteria.title.text.value) return null;
          const isSelected = filter.key === "price" ? isSortSelected(criteria?.key || "") : isFilterSelected(filter?.key, criteria.title.text.value);
          const handleChange = filter.key === "price" ? () => handleSortChange(criteria?.key || "", criteria?.title?.text?.value || "") : () => handleFilterChange(filter.key, criteria.title.text.value, filter.type);
          return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: filter.type === "checkbox" ? /*#__PURE__*/(0,jsx_runtime.jsx)(CheckboxItem, {
              "data-test-id": `FilterPlans-CheckboxItem-${criteriaIndex}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.CheckButton, {
                inputId: `${filter.key}-${criteriaIndex}`,
                isChecked: isSelected,
                handleChange: e => {
                  e.preventDefault();
                  handleChange();
                },
                "data-test-id": "FilterPlans-CheckButton",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
                  fontSize: "sm",
                  color: Global/* theme.blackText */.rS.blackText,
                  margin: "0",
                  "data-test-id": "FilterPlans-ParaTag",
                  children: criteria.title.text.value
                })
              })
            }, criteriaIndex) : /*#__PURE__*/(0,jsx_runtime.jsx)(CheckboxItem, {
              "data-test-id": `FilterPlans-CheckboxItem-${criteriaIndex}`,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.RadioButton, {
                inputId: `${filter.key}-${criteriaIndex}`,
                activeBtn: isSelected,
                inputIndex: criteriaIndex,
                handleChange: e => {
                  handleChange();
                },
                "data-test-id": "FilterPlans-RadioButton",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(components.ParaTag, {
                  fontSize: "sm",
                  color: Global/* theme.blackText */.rS.blackText,
                  margin: "0",
                  "data-test-id": "FilterPlans-ParaTag",
                  children: criteria.title.text.value
                })
              })
            }, criteriaIndex)
          });
        })]
      }), filterIndex < filterList.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Divider, {
        "data-test-id": "FilterPlans-Divider"
      })]
    }, filter.key))
  });
};

/* harmony default export */ const FilterPlans_FilterPlans = (FilterPlans);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/mypartner/PersuasionComponent/PersuasionComponent.tsx + 1 modules
var PersuasionComponent = __webpack_require__(25233);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/mypartner/PlanCardsList/PlanCardsList.tsx + 6 modules
var PlanCardsList = __webpack_require__(14424);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/MyPartnerComponentMapper.ts












/**
 * MyPartner-specific component mapper to avoid circular dependencies
 * This is a duplicate of the main ComponentMapper but with direct imports
 * to break the circular dependency chain
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any

const MYPARTNER_COMPONENT_MAPPER = {
  top: {
    HEADER_TITLE: HeaderTitleComp/* default */.Z
  },
  left: {
    COMPONENT_MYPARTNER_LISTING_PAGE_FILTER_PLANS: FilterPlans_FilterPlans,
    COMPONENT_MYPARTNER_TRAVELLER_ATTRIBUTE_ITINERARY_INFO: ItineraryInfoComp/* default */.Z,
    COMPONENT_MYPARTNER_TRAVELLER_ATTRIBUTE_PLAN_INFO: PlanPriceInfoComp/* default */.Z,
    COMPONENT_MYPARTNER_BUYNOW: LandingButtonComp/* default */.Z,
    COMPONENT_MYPARTNER_TRAVELLER_ATTRIBUTE_DISCLAIMER: DisclaimerComp/* default */.Z,
    COMPONENT_MYPARTNER_TRAVELLER_ATTRIBUTE_TNC: TncComp/* default */.Z,
    PRIMARY_CONTACT: PrimaryContactComp/* default */.Z,
    COMPONENT_TRAVELLER_ATTRIBUTE_PAGE_TRAVELLER_DETAIL: AddTravellerDetailsComp/* default */.Z
  },
  right: {
    INSURANCE_CARDS: PlanCardsList/* default */.Z,
    PERSUASION: PersuasionComponent/* default */.Z,
    COMPONENT_MYPARTNER_LISTING_PAGE_ITINERARY_INFO: ItineraryInfoComp/* default */.Z,
    PRICE_BREAKUP: PriceBreakup/* default */.Z
  }
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/ComponentRenderer.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




/**
 * Generic component card interface that matches the structure from API
 */




/**
 * Reusable component renderer that handles the mapping and transformation logic
 * This eliminates the repeated code in top, left, and right sections
 */
const ComponentRenderer = ({
  components,
  layout,
  csrfToken
}) => {
  if (!components) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: components.map((card, index) => {
      const CardComponent = MYPARTNER_COMPONENT_MAPPER[layout][card.id];
      const transformer = COMPONENT_TRANSFORMER[card.id];

      if (CardComponent) {
        // Generate a more unique key using component ID and index
        const key = `${card.id}-${index}`;

        if (transformer) {
          // Use transformer and spread transformed data as props
          const transformedData = transformer(card.data); // Type check before spreading

          if (transformedData && typeof transformedData === "object") {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(CardComponent, _objectSpread(_objectSpread({}, transformedData), {}, {
              csrfToken: csrfToken,
              "data-test-id": `ComponentRenderer-CardComponent-${key}`
            }), key);
          }

          return /*#__PURE__*/(0,jsx_runtime.jsx)(CardComponent, {
            data: transformedData,
            csrfToken: csrfToken,
            "data-test-id": `ComponentRenderer-CardComponent-${key}`
          }, key);
        } else {
          // No transformer, spread props directly
          // Type check before spreading
          if (card.data && typeof card.data === "object") {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(CardComponent, _objectSpread(_objectSpread({}, card.data), {}, {
              csrfToken: csrfToken,
              "data-test-id": `ComponentRenderer-CardComponent-${key}`
            }), key);
          }

          return /*#__PURE__*/(0,jsx_runtime.jsx)(CardComponent, {
            data: card.data,
            csrfToken: csrfToken,
            "data-test-id": `ComponentRenderer-CardComponent-${key}`
          }, key);
        }
      }

      return null;
    })
  });
};
/* harmony default export */ const mypartner_ComponentRenderer = ((/* unused pure expression or super */ null && (ComponentRenderer)));
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/mypartner/index.ts
// Export component mapper (primary export - used by ComponentRenderer)
// Export component renderer utility (used by InsuranceListingV2)



/***/ })

}]);